import { Box, IconButton, TextField, Button, Typography, Checkbox, Card, CardContent, Drawer, Tabs, styled, Tab, Collapse, Dialog, FormControlLabel, ListItemButton, Menu, MenuItem, Popover, Select, Tooltip, Switch  } from "@mui/material";
import { useCallback, useContext, useEffect, useMemo, useRef, useState } from "react";
import _ from "lodash";
import { getDataSource } from "api/ds";
import { ReportTable } from "components/reportTable";
import { loginSelector } from "store/slices/loginSlice";
import { useDispatch, useSelector } from "react-redux";
import Loading from "components/Load";
import { get, post } from "api/apiBridges/httpBridge";
import Scrollbars from "rc-scrollbars";
import useOn from 'components/socketLib/UseOn';
import { MarketClientSelector } from "store/slices/marketClient";
import { useLocalNotifications } from "components/Events";
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import { SocketContext } from "components/socketLib/ConnectorSocket";
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import CancelIcon from '@mui/icons-material/Cancel';
import { SelectMarketLocal } from "components/SelectMarket";
import { colors } from "styles/colors";
import ListAltIcon from '@mui/icons-material/ListAlt';
import { ElementInfo } from "components/ElementInfo";
import DeleteForeverIcon from '@mui/icons-material/DeleteForever';
import ClientsList from "components/ClientsList";
import { fetchData } from "pdfjs-dist";
import { TabPanel } from "components/tabPanel";
import { ExpandLess, ExpandMore } from "@mui/icons-material";
import handleConfirm from "components/AlertMessage";
import usePreventDoubleClick from "components/AntiDBC";
import ClassicSearch from "components/classicSearch";
import { NumInputDesign, DropdownMenu } from "components/EIComponents/LittleComponents";
import { genDoc } from "components/genDoc";
import { ShowModal } from "components/Modal";
import { DealTab, ProductMoreInfo } from "utils/formatters";
import { mergeConsumFromDealArrays } from "./deal";
import AddIcon from '@mui/icons-material/Add';
import MuiInput from '@mui/material/Input';
import NorthIcon from '@mui/icons-material/North';
import SouthIcon from '@mui/icons-material/South';
import { useNavigate } from "react-router-dom";
import { hoverStyle } from "styles/main";

export function Returns() {
    const ds = useMemo(() => getDataSource('ReturnsTable'), []);
    const EIDS = useMemo(() => getDataSource('ReturnsDealsAdmin'), []);
    /** @type {[any, Function]} */
    const [data, setData] = useState({});
    const [market, setMarket] = useState("wb");
    const [loading, setLoading] = useState(true);
    /** @type {[any, Function]} */
    const [clients, setClients] = useState([]);
    /** @type {[any, Function]} */
    const [selectedCli, setSelectedCli] = useState(undefined);
    const [tabIdx, setTabIdx] = useState("return");
    const handleChange = (event, newValue) => setTabIdx(newValue);


    /** @type {[any, Function]} */
    const [returnDealId, setReturnDealId] = useState(undefined);
    /** @type {[any, Function]} */
    const [cancelReturn, setCancelReturn] = useState(undefined);
    /** @type {[any, Function]} */
    const [selfReturnDealId, setSelfReturnDealId] = useState(undefined);
    /** @type {[any, Function]} */
    const [cancelSelfReturn, setCancelSelfReturn] = useState(undefined);
    /** @type {[any, Function]} */
    const [defectDealId, setDefectDealId] = useState(undefined);
    /** @type {[any, Function]} */
    const [cancelDefect, setCancelDefect] = useState(undefined);
    /** @type {[any, Function]} */
    const [history, setHistory] = useState([]);
    

    /** @type {any} */
    const textref = useRef(null);

    const { showNotification } = useLocalNotifications();

    const { socket } = useContext(SocketContext);

    const { company_id, user_id  } = useSelector(
        loginSelector
    );

    const fetchData = async () => {
        setLoading(true)
        let clis = await get("Clients/getOnCompany", {cid: company_id})
        console.log(clis)
        clis.message.map((el) => {if (el.data && el.data !== "") {el.data = JSON.parse(el.data)}; el.manager = el.managers[0]})
        setClients(clis.message)
        setLoading(false)
        if (textref.current) {
            textref.current.focus();
        }
    }

    useEffect(() => {
        fetchData()
    }, []);


    useEffect(() => {

        const takeDealsIds = async () => {
            let returnDeal = await get('Deal/getCliRetunsDeal', {cid: selectedCli.id, market})
            if (returnDeal.deal) {setReturnDealId(returnDeal.deal)}    
            else {
                setReturnDealId(undefined)
            }        
            let selfReturnDeal = await get('Deal/getCliSelfRetunsDeal', {cid: selectedCli.id, market})
            if (selfReturnDeal.deal) {setSelfReturnDealId(selfReturnDeal.deal)}    
            else {
                setSelfReturnDealId(undefined)
            }        
            let defectDeal = await get('Deal/getCliStorageDefect', {cid: selectedCli.id, market})
            if (defectDeal.deal) {setDefectDealId(defectDeal.deal)}    
            else {
                setDefectDealId(undefined)
            }   
            setHistory([])
        }

        if (selectedCli) {
            takeDealsIds()
        }
    }, [selectedCli, market]);

    

    const changeMarket = (m) => {
        setMarket(m)
    }
    

    const createReturnDeal = async () => {
        setLoading(true)
        let nd = await post('Deal/create', 
            {
                products: [], 
                count_bale: 0, 
                warehouse_tranzit: "", 
                warehouse_market: "", 
                date_shipment: new Date(), 
                id_company: company_id, 
                id_client: selectedCli.id, 
                id_manager: selectedCli.manager.id, 
                market: market, 
                number_order: "",
                status: 1, 
                type: "returns",
                data:{
                    sku: 0,
                    units: 0,
                    end_date:new Date(),
                }
            })
        if (nd?.id) {
            //Лог о содании сделки
            await post("Logs/create", {
                deal_id:nd.id,
                user_type:"ful",
                user_id,
                type: "create_deal",
                data: {
                    sku:0,
                    units: 0,
                }
            })
            socket.emit('add_new_deal', {company_id, type: "moving_deals", id:nd.id});
            setReturnDealId(nd.id)
        }
        setLoading(false)

    }
    
    const createSelfReturnDeal = async () => {
        setLoading(true)
        let nd = await post('Deal/create', 
            {
                products: [], 
                count_bale: 0, 
                warehouse_tranzit: "", 
                warehouse_market: "", 
                date_shipment: new Date(), 
                id_company: company_id, 
                id_client: selectedCli.id, 
                id_manager: selectedCli.manager.id, 
                market: market, 
                number_order: "",
                status: 1, 
                type: "selfreturns",
                data:{
                    sku: 0,
                    units: 0,
                    end_date:new Date(),
                }
            })
        if (nd?.id) {
            //Лог о содании сделки
            await post("Logs/create", {
                deal_id:nd.id,
                user_type:"ful",
                user_id,
                type: "create_deal",
                data: {
                    sku:0,
                    units: 0,
                }
            })
            socket.emit('add_new_deal', {company_id, type: "moving_deals", id:nd.id});
            setSelfReturnDealId(nd.id)
        }
        setLoading(false)

    }
    
    const createDefectDeal = async () => {
        setLoading(true)
        let nd = await post('Deal/create', 
            {
                products: [], 
                count_bale: 0, 
                warehouse_tranzit: "", 
                warehouse_market: "", 
                date_shipment: new Date(), 
                id_company: company_id, 
                id_client: selectedCli.id, 
                id_manager: selectedCli.manager.id, 
                market: market, 
                number_order: "",
                status: 1, 
                type: "products_storage",
                canCancel: false,
                data:{
                    sku: 0,
                    units: 0,
                    end_date:new Date(),
                    defect: true,
                }
            })
        if (nd?.id) {
            //Лог о содании сделки
            await post("Logs/create", {
                deal_id:nd.id,
                user_type:"ful",
                user_id,
                type: "create_deal",
                data: {
                    sku:0,
                    units: 0,
                }
            })
            socket.emit('add_new_deal', {company_id, type: "products_storage", id:nd.id});
            setDefectDealId(nd.id)
        }
        setLoading(false)

    }

    const getHistoryCard = (item, ind) => {

        let title = ""
        // switch (item.type) {
        //     case "return": {title += "Возвраты - "; break}
        //     case "selfret": {title += "Самовыкуп - "; break}
        //     case "defect": {title += "Брак - "; break}
        // }

        switch (item.actionType) {
            case "productToBox": {
                title += `${item.barcode} -> ${item.box.title} - ${item.count}шт.`
                break;
            }
        }

        return (
            <div style={{ width: "100%", display: 'flex', flexDirection: "row", alignItems: 'center', justifyContent: 'space-between'}}>
                <Typography>{title}</Typography>
                <IconButton 
                    onClick={() => {
                        switch (item.type) {
                            case "return": {setCancelReturn([item]); break}
                            case "selfret": {setCancelSelfReturn([item]);  break}
                            case "defect": {setCancelDefect([item]); ; break}
                        }
                        let tmp = JSON.parse(JSON.stringify(history))
                        tmp.splice(ind, 1);
                        setHistory(tmp)
                    }}
                >
                    <DeleteForeverIcon
                        sx={{
                            transition: 'all 0.3s ease',
                            '&:hover': hoverStyle
                        }}
                    />
                </IconButton>
            </div>
        )
    }

    const addToHistory = (items) => {
        let tmp = JSON.parse(JSON.stringify(history))
        for (let el of items) {
            tmp.push(el)
        }
        setHistory(tmp)
    }

    // let buttonBlock = loading || Object.values(data).length === 0 || Object.values(data).filter((el) => el.status === 'load').length >0

    return (
        <Box sx={{height: '100%', width: "100%"}}>
            <div style={{width: "98%", height: "100%", margin: "0 1% 0 1%"}}>
                <div style={{width: "100%", height: "7%", display: 'flex', flexDirection: 'row', alignItems: 'center'}}>
                    {loading? <Loading/> : <div style={{width: "20%"}}><ClientsList list={clients} selected={selectedCli} onSelect={(v) => {setSelectedCli(v)}} editable={true}/></div>}
                    <SelectMarketLocal markets={['wb', 'ozon', 'custom']} market={market} save={(m) => changeMarket(m)}/>
                </div>
                <div style={{width: "100%", height: "93%", display: 'flex', flexDirection: "row", justifyContent: 'space-between'}}>
                    <div style={{
                        width: "70%", 
                        height: "100%", 
                    }}>
                        {loading?
                            <Loading />
                            :
                            <>
                                <Tabs 
                                    value={tabIdx} 
                                    onChange={handleChange} 
                                    sx={{
                                        "& .MuiTabs-indicator": {
                                            display: "none"
                                        },
                                        height: "30px",
                                        minHeight: "30px"
                                    }}
                                >
                                        <DealTab label='ВОЗВРАТЫ' value={'return'} />
                                        <DealTab label='САМОВЫКУП' value={'selfreturn'} />
                                        <DealTab label='БРАК' value={'defect'} />
                                </Tabs>
                                <TabPanel select={tabIdx} value={'return'} >
                                    {selectedCli ? 
                                        <>
                                        {returnDealId !== undefined ?
                                            <CutedBind 
                                                deal_id={returnDealId} 
                                                cliID={selectedCli.id} 
                                                addToHistory={addToHistory} 
                                                type={"return"}
                                                cancelList={cancelReturn}
                                                clearCancelList={() => {setCancelReturn(undefined)}}
                                            />
                                        :
                                            <div  
                                                style={{
                                                    display: "flex", 
                                                    flexDirection: "column", 
                                                    alignItems: 'flex-start',
                                                    height: "calc(100% - 50px )", 
                                                    width: '98%',
                                                    backgroundColor: 'white', 
                                                    borderRadius: "10px", 
                                                    borderTopLeftRadius: tabIdx === "return"? "0px": "10px",
                                                    padding: "3%"
                                                }}>
                                                <Button 
                                                    variant="contained" 
                                                    onClick={(e) => {createReturnDeal()}} 
                                                    sx={{ textTransform: 'none', fontWeight: 'bold', backgroundColor: colors.elements, whiteSpace: 'nowrap', width: "150px", borderRadius: '10px' }}
                                                >
                                                    Создать сделку
                                                </Button>
                                            </div>
                                        }
                                        </>
                                    :
                                        <div  
                                            style={{
                                                display: "flex", 
                                                flexDirection: "column", 
                                                alignItems: 'flex-start',
                                                height: "calc(100% - 50px )", 
                                                width: '98%',
                                                backgroundColor: 'white', 
                                                borderRadius: "10px", 
                                                borderTopLeftRadius: tabIdx === "return"? "0px": "10px",
                                                padding: "3%"
                                            }}
                                        >
                                            <Typography sx={{fontSize: "16pt"}}>Для начала работы необходимо выбрать клиента</Typography>
                                        </div>
                                    }
                                </TabPanel>
                                <TabPanel select={tabIdx} value={'selfreturn'} >
                                    {selectedCli ? 
                                        <>
                                        {selfReturnDealId !== undefined ?
                                            <CutedBind 
                                                deal_id={selfReturnDealId} 
                                                cliID={selectedCli.id} 
                                                addToHistory={addToHistory} 
                                                type={"selfreturn"}
                                                cancelList={cancelSelfReturn}
                                                clearCancelList={() => {setCancelSelfReturn(undefined)}}
                                            />
                                        :
                                            <div  
                                                style={{
                                                    display: "flex", 
                                                    flexDirection: "column", 
                                                    alignItems: 'flex-start',
                                                    height: "calc(100% - 50px )", 
                                                    width: '98%',
                                                    backgroundColor: 'white', 
                                                    borderRadius: "10px", 
                                                    borderTopLeftRadius: tabIdx === "return"? "0px": "10px",
                                                    padding: "3%"
                                                }}>
                                                <Button 
                                                    variant="contained" 
                                                    onClick={(e) => {createSelfReturnDeal()}} 
                                                    sx={{ textTransform: 'none', fontWeight: 'bold', backgroundColor: colors.elements, whiteSpace: 'nowrap', width: "150px", borderRadius: '10px' }}
                                                >
                                                    Создать сделку
                                                </Button>
                                            </div>
                                        }
                                        </>
                                    :
                                        <div  
                                            style={{
                                                display: "flex", 
                                                flexDirection: "column", 
                                                alignItems: 'flex-start',
                                                height: "calc(100% - 50px )", 
                                                width: '98%',
                                                backgroundColor: 'white', 
                                                borderRadius: "10px", 
                                                borderTopLeftRadius: tabIdx === "return"? "0px": "10px",
                                                padding: "3%"
                                            }}
                                        >
                                            <Typography sx={{fontSize: "16pt"}}>Для начала работы необходимо выбрать клиента</Typography>
                                        </div>
                                    }
                                </TabPanel>
                                <TabPanel select={tabIdx} value={'defect'} >
                                    {selectedCli ? 
                                        <>
                                        {defectDealId !== undefined ?
                                            <CutedBind 
                                                deal_id={defectDealId} 
                                                cliID={selectedCli.id} 
                                                addToHistory={addToHistory} 
                                                type={"defect"}
                                                cancelList={cancelDefect}
                                                clearCancelList={() => {setCancelDefect(undefined)}}
                                            />
                                        :
                                            <div  
                                                style={{
                                                    display: "flex", 
                                                    flexDirection: "column", 
                                                    alignItems: 'flex-start',
                                                    height: "calc(100% - 50px )", 
                                                    width: '98%',
                                                    backgroundColor: 'white', 
                                                    borderRadius: "10px", 
                                                    borderTopLeftRadius: tabIdx === "return"? "0px": "10px",
                                                    padding: "3%"
                                                }}>
                                                <Button 
                                                    variant="contained" 
                                                    onClick={(e) => {createDefectDeal()}} 
                                                    sx={{ textTransform: 'none', fontWeight: 'bold', backgroundColor: colors.elements, whiteSpace: 'nowrap', width: "150px", borderRadius: '10px' }}
                                                >
                                                    Создать сделку
                                                </Button>
                                            </div>
                                        }
                                        </>
                                    :
                                        <div  
                                            style={{
                                                display: "flex", 
                                                flexDirection: "column", 
                                                alignItems: 'flex-start',
                                                height: "calc(100% - 50px )", 
                                                width: '98%',
                                                backgroundColor: 'white', 
                                                borderRadius: "10px", 
                                                borderTopLeftRadius: tabIdx === "return"? "0px": "10px",
                                                padding: "3%"
                                            }}
                                        >
                                            <Typography sx={{fontSize: "16pt"}}>Для начала работы необходимо выбрать клиента</Typography>
                                        </div>
                                    }
                                </TabPanel>
                                
                            </>
                        }
                    </div>
                    <div 
                        style={{
                            width: "30%", 
                            height: "calc(100% - 50px )", 
                            backgroundColor: 'white', 
                            marginTop: "30px",
                            borderRadius: "10px"
                        }}
                    >
                        <Scrollbars
                            style={{ 
                                width: '100%', 
                                height: '100%', 
                                borderBottomLeftRadius: "10px", 
                                borderBottomRightRadius: "10px"
                            }}
                        >
                            {history.filter((fel) => fel.type === tabIdx).map((item, index) => 
                                <Card
                                    key={index} // или используйте уникальный id, если есть
                                    sx={{ 
                                        margin: 1,
                                        borderRadius: "30px",
                                        boxShadow: 1,
                                        height: '8%',
                                        display: 'flex',
                                        alignItems: 'center',
                                        width: "90%",
                                        marginLeft: "5%"
                                    }}
                                >
                                    <CardContent sx={{flex: 1, display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginTop:"8px"}}>
                                        {getHistoryCard(item, index)}
                                    </CardContent>
                                </Card>
                            )}
                        </Scrollbars>
                    </div>
                </div>
            </div>
        </Box>
    );
}

const BoxPalletSwitch = styled(Switch)(({ theme }) => ({
    width: '120px',
    height: 30,
    padding: 0,
    margin: 0,
    position: 'relative',

    '& .MuiSwitch-switchBase': {
        padding: 0,
        margin: 0,
        top: '45%',
        // Начальный отступ слева (2 пикселя)
        transform: 'translateX(2px) translateY(-50%)',

        '&.Mui-checked': {
            // Отступ справа тоже 2 пикселя: 120 - 60 - 2 = 58px смещения
            transform: 'translateX(58px) translateY(-50%)',
            color: '#fff',

            '& .MuiSwitch-thumb:before': {
                content: "'Паллет'",
            },
            '& + .MuiSwitch-track': {
                opacity: 1,
                backgroundColor: 'rgba(255, 255, 255, 0.6)',
            },
        },
    },

    '& .MuiSwitch-track': {
        borderRadius: 10,
        margin: 0,
        backgroundColor: 'rgba(255, 255, 255, 0.6)',
        opacity: 1,

        '&::before, &::after': {
            position: 'absolute',
            top: '45%',
            transform: 'translateY(-50%)',
            lineHeight: 1,
        },
        '&::before': {
            content: "'Короб'",
            left: 4,
        },
        '&::after': {
            content: "'Паллет'",
            right: 4,
        },
    },

    '& .MuiSwitch-thumb': {
        boxShadow: 'none',
        backgroundColor: colors.status.high,
        opacity: 1,
        width: 60,
        height: 25,
        marginBlock: 0,
        padding: 0,
        borderRadius: 10,

        '&::before': {
            position: 'absolute',
            top: '45%',
            left: 6,
            transform: 'translateY(-50%)',
            lineHeight: 1,
            content: "'Короб'",
        },
    },
}));

const BoxProductSwitch = styled(Switch)(({ theme }) => ({
    width: '120px',
    height: 30,
    padding: 0,
    margin: 0,
    position: 'relative',

    '& .MuiSwitch-switchBase': {
        padding: 0,
        margin: 0,
        top: '45%',
        // Начальный отступ слева (2 пикселя)
        transform: 'translateX(2px) translateY(-50%)',

        '&.Mui-checked': {
            // Отступ справа тоже 2 пикселя: 120 - 60 - 2 = 58px смещения
            transform: 'translateX(58px) translateY(-50%)',
            color: '#fff',

            '& .MuiSwitch-thumb:before': {
                left:8,
                content: "'Товар'",
            },
            '& + .MuiSwitch-track': {
                opacity: 1,
                backgroundColor: 'rgba(255, 255, 255, 0.6)',
            },
        },
    },

    '& .MuiSwitch-track': {
        borderRadius: 10,
        margin: 0,
        backgroundColor: 'rgba(255, 255, 255, 0.6)',
        opacity: 1,

        '&::before, &::after': {
            position: 'absolute',
            top: '45%',
            transform: 'translateY(-50%)',
            lineHeight: 1,
        },
        '&::before': {
            content: "'Короб'",
            left: 4,
        },
        '&::after': {
            content: "'Товар'",
            right: 4,
        },
    },

    '& .MuiSwitch-thumb': {
        boxShadow: 'none',
        backgroundColor: colors.status.high,
        opacity: 1,
        width: 60,
        height: 25,
        marginBlock: 0,
        padding: 0,
        borderRadius: 10,

        '&::before': {
            position: 'absolute',
            top: '45%',
            left: 6,
            transform: 'translateY(-50%)',
            lineHeight: 1,
            content: "'Короб'",
        },
    },
}));

function CutedBind ({deal_id, cliID, addToHistory, type, cancelList, clearCancelList}) {
    const [loading, setLoading] = useState(false);
    const [dOpen, setDOpen] = useState(false);
    const [noPalletOpen, setNoPalletOpen] = useState(true);
    /** @type {[any, Function]} */
    const [data, setData] = useState({});
    /** @type {[Array<any>, Function]} */
    const [boxes, setBoxes] = useState([]);
    /** @type {[Array<any>, Function]} */
    const [changed, setChanged] = useState([]);
    const [selBox, setSelBox] = useState(undefined);
    const [addBoxCount, setAddBoxCount] = useState(1);
    const [addPalletCount, setAddPalletCount] = useState(1);


    const [dealNumber, setDealNumber] = useState(null);
    const [idSortOrder, setIdSortOrder] = useState(localStorage.getItem('bindDeal_sortOrder') || 'asc')

    const [allCountBinded, setAllCountBinded] = useState(0);
    const [allSkuBinded, setAllSkuBinded] = useState(0);
    const [boxesCount, setBoxesCount] = useState(0);
    const [inPalletCount, setInPalletCount] = useState({})
    const [market, setMarket] = useState(undefined);

    const [openDealInfo, setOpenDealInfo] = useState(false);
    const [unsavedChanges, setUnsavedChanges] = useState(false);

    const [anchorBP, setAnchorBP] = useState(null); // якорь для Popover
    const handleOpenBP = (event) => {
        setAnchorBP(event.currentTarget); // привязываем окно к кнопке
    };
    const handleCloseBP = () => {
        setAnchorBP(null);
    };
    const openBP = Boolean(anchorBP);
    const [addTypeBP, setAddTypeBP] = useState(true); 



    const [checked, setChecked] = useState(false);
    /** @type {[any, Function]} */
    const [filter, setFilter] = useState(null);
    const [filterFields, setFilterFields] = useState(
        {
            title: {name: "Название", active: true},
            brand: {name: "Брэнд", active: true},
            vendorCode: {name: "Артикул", active: true},
            barcode: {name: "ШК", active: true},
            color: {name: "Цвет", active: true},
            size: {name: "Размер", active: true}
        }
    );
    /** @type {[Array<any>, Function]} */
    const [finded, setFinded] = useState([]);


    const { user_id, company_id } = useSelector(
        loginSelector
    );

    const { showNotification } = useLocalNotifications();
    const preventDoubleClick = usePreventDoubleClick();
    const navigate = useNavigate();

    const boxSort = (list) => {
        const currentSort = localStorage.getItem('bindDeal_sortOrder') || 'asc';

        return list.sort((a, b) => {
            const partsA = a.title.split('_');
            const partsB = b.title.split('_');

            for (let i = 0; i < partsA.length; i+=2) {//+2 делается, чтобы не сравнивать по клиенту, он всегда одинаковый
            // Извлекаем число из каждой части (предполагается, что часть содержит цифры)
            const numA = parseInt(partsA[i].match(/\d+/)?.[0] || '0', 10);
            const numB = parseInt(partsB[i].match(/\d+/)?.[0] || '0', 10);

            if (numA !== numB) {
                // Числовое сравнение
                return currentSort === 'asc' ? numA - numB : numB - numA;
            }
            // Если числа равны, переходим к следующей части
            }
            // Все части совпадают — объекты эквивалентны
            return 0;
        });
    };


    const handleClick = (id) => {
        setScrollPosition()
        let tmp = [...boxes]
        let idx = tmp.findIndex((el) => el.id === id)
        tmp[idx].open = !tmp[idx].open
        setBoxes(boxSort(tmp))
    };

    const fetchData = useCallback(async () => {
        try {
            setLoading(true);
            const [res, dealRes, respb] = await Promise.all([
                get("Deal/GetProductsWithBoxOnDeal", {did:deal_id}),
                get("Deal/get", {did:deal_id}),
                get("Boxes/GetOnDeal", {did:deal_id}),
            ])

            let deal = dealRes.message
            deal.data = JSON.parse(deal.data)

            setDealNumber(deal.data.cdn);
            
            const mr = deal.market
            const tmpMW = deal.data?.MW || []


            setMarket(mr)

            let skulist = []
            let result = {}
            for (let card of res) {
                let obj = {
                    ...card,
                    data: {
                        market: mr,
                        vendorCode:card.vendorCode,
                        brand:card.brand,
                        title:card.title,
                        photo:card.photo,
                        color:card.color,
                        dimensions: card.dimensions,
                        material:card.material,
                        barcode:card.size.barcode,
                        sizeTitle:card.size.title,
                        url: card.size.url,
                        nmID: card.size?.ozonID || card.nmID
                    },
                }
                if (Object.keys(result).includes(""+card.box_id)) {
                    result[card.box_id].push(obj)
                }
                else {result[card.box_id] = [{...obj}]}
                if (card.box_id !== 0 && !skulist.includes(obj.data.barcode)) {skulist.push(obj.data.barcode)}
            }
            Object.keys(result).forEach(boxId => {
                result[boxId].sort((a, b) => {
                    const barcodeA = String(a.data.barcode || '');
                    const barcodeB = String(b.data.barcode || '');
                    
                    // Сначала сортируем по баркоду товара
                    if (barcodeA !== barcodeB) {
                        return barcodeA.localeCompare(barcodeB);
                    }
                    
                    // Если баркоды совпадают, сортируем по id для абсолютной стабильности
                    return (a.id || 0) - (b.id || 0);
                });
            });
            setData(result)
            let resb = []
            let AC = 0
            respb.map((el) => {
                resb.push({...el, open:false, openMenu: null, openSelectPallet: null})
                AC += parseInt(el.count)
            })
            
            setAllCountBinded(AC)
            setAllSkuBinded(skulist.length)
            
            setBoxes(boxSort(resb));
            
        }
        catch {}
        finally {setLoading(false);}
    }, []);
    
    useEffect(() => {
        fetchData();
    }, [deal_id]);

    useEffect(() => {
        setBoxesCount(boxes.filter(box => box.type === 'box').length)
    }, [data, boxes]); 


    const addProductCalc = async ($selBox, targetBox, products, workData) => {
        console.log("ADD PTOCALC MAIN", $selBox, targetBox, products, workData)
        
        let reserv = JSON.parse(JSON.stringify(workData))
        let TSproductUpdate = [] //post("products/update",
        let TSboxUpdate = [] //post('Boxes/update',
        let TSCreatedProducts = [] //Товары, которые были созданы
        let GlobalErr = false
        
        let tmp = JSON.parse(JSON.stringify(workData))
        let logsData = []
        let ECBuf = 0 //Переменная нужная для учета отрицательного количества заявленных товаров при удалении старого товара
        for (let card of products){
            console.log("APC", tmp, card.box_id, card.id)
            let idx = tmp[card.box_id].findIndex((el) => el.id === card.id)
            console.log("APC2", idx)
            let needAddToFromDealPackage = {}
            let needAddToFromDealConsumes = {}
            let needAddToFromDealAdditConsumes = {}
            let del = false
            if (tmp[card.box_id][idx].countProduct === card.countProduct) {
                //весь товар распределен
                ECBuf = tmp[card.box_id][idx].countEtimated - card.countProduct
                del = true

                // post("products/delete", [tmp[card.box_id][idx].id])
                //Вместо удаления имеет смысл оставлять в нулевом коробе с нулевыми количествами, так как при других изменениях это все равно будет работать так
                //Если мы удаляем товар из нулевого короба полностью, то нас не интересует, сколько там оставалось расходников
                TSproductUpdate.push(
                    {old: 
                        {
                            id:reserv[card.box_id][idx].id, 
                            countProduct:reserv[card.box_id][idx].countProduct, 
                            countEtimated:reserv[card.box_id][idx].countEtimated,
                            countProductHist:reserv[card.box_id][idx].countProductHist, 
                            package:reserv[card.box_id][idx].package || [],
                            consumes:reserv[card.box_id][idx].consumes || [],
                            addit_cons:reserv[card.box_id][idx].addit_cons || []
                        },
                    new:
                        {
                            id:tmp[card.box_id][idx].id, 
                            countProduct:0, 
                            countEtimated:0,
                            countProductHist:0, 
                            package:[],
                            consumes:[],
                            addit_cons:[]
                        }
                    }
                )
            }
            else {
                //распределена часть товара
                tmp[card.box_id][idx].countProduct -= card.countProduct
                tmp[card.box_id][idx].countEtimated -= card.countProduct//Вычитается столько, сколько мы хотим добавить
                if (tmp[card.box_id][idx].countProductHist) {
                    tmp[card.box_id][idx].countProductHist -= card.countProduct
                }
                else {tmp[card.box_id][idx].countProductHist = tmp[card.box_id][idx].countProduct}
                console.log("Добавляемый товар", card)
                //Тут нам надо посчитать сколько расходников останется
                //Для упаковки
                if (tmp[card.box_id][idx].package) {
                    tmp[card.box_id][idx].package.map((cons) => {
                        if (cons.fromDeal) {
                            let consumNeedCountDel = cons.count * card.countProduct
                            if (!needAddToFromDealPackage[cons.id]) {
                                needAddToFromDealPackage[cons.id] = []
                            }
                            cons.fromDeal.map((ofd) => {
                                if (consumNeedCountDel > 0) {
                                    if (ofd.count >= consumNeedCountDel) {
                                        let fdtmp = {deal:ofd.deal, count:consumNeedCountDel}
                                        if (ofd.box) {fdtmp.box = ofd.box}
                                        needAddToFromDealPackage[cons.id].push(fdtmp)
                                        ofd.count = ofd.count - consumNeedCountDel
                                        consumNeedCountDel = 0
                                    }
                                    else {
                                        if (ofd.count > 0) {
                                            let fdtmp = {deal:ofd.deal, count:ofd.count}
                                            if (ofd.box) {fdtmp.box = ofd.box}
                                            needAddToFromDealPackage[cons.id].push(fdtmp)
                                            consumNeedCountDel = consumNeedCountDel - ofd.count
                                            ofd.count = 0
                                        }
                                    }
                                }
                            })
                        }
                    })
                }
                //Для комплектации
                if (tmp[card.box_id][idx].consumes) {
                    tmp[card.box_id][idx].consumes.map((cons) => {
                        if (cons.fromDeal) {
                            let consumNeedCountDel = cons.count * card.countProduct
                            if (!needAddToFromDealConsumes[cons.id]) {
                                needAddToFromDealConsumes[cons.id] = []
                            }
                            cons.fromDeal.map((ofd) => {
                                if (ofd.count >= consumNeedCountDel) {
                                    let fdtmp = {deal:ofd.deal, count:consumNeedCountDel}
                                    if (ofd.box) {fdtmp.box = ofd.box}
                                    needAddToFromDealConsumes[cons.id].push(fdtmp)
                                    ofd.count = ofd.count - consumNeedCountDel
                                    consumNeedCountDel = 0
                                }
                                else {
                                    if (ofd.count > 0) {
                                        let fdtmp = {deal:ofd.deal, count:ofd.count}
                                        if (ofd.box) {fdtmp.box = ofd.box}
                                        needAddToFromDealConsumes[cons.id].push(fdtmp)
                                        consumNeedCountDel = consumNeedCountDel - ofd.count
                                        ofd.count = 0
                                    }
                                }
                            })
                        }
                    })
                }
                //Для расходников
                if (tmp[card.box_id][idx].addit_cons) {
                    tmp[card.box_id][idx].addit_cons.map((cons) => {
                        if (cons.fromDeal) {
                            let consumNeedCountDel = cons.count * card.countProduct
                            if (!needAddToFromDealAdditConsumes[cons.id]) {
                                needAddToFromDealAdditConsumes[cons.id] = []
                            }
                            cons.fromDeal.map((ofd) => {
                                if (ofd.count >= consumNeedCountDel) {
                                    let fdtmp = {deal:ofd.deal, count:consumNeedCountDel}
                                    if (ofd.box) {fdtmp.box = ofd.box}
                                    needAddToFromDealAdditConsumes[cons.id].push(fdtmp)
                                    ofd.count = ofd.count - consumNeedCountDel
                                    consumNeedCountDel = 0
                                }
                                else {
                                    if (ofd.count > 0) {
                                        let fdtmp = {deal:ofd.deal, count:ofd.count}
                                        if (ofd.box) {fdtmp.box = ofd.box}
                                        needAddToFromDealAdditConsumes[cons.id].push(fdtmp)
                                        consumNeedCountDel = consumNeedCountDel - ofd.count
                                        ofd.count = 0
                                    }
                                }
                            })
                        }
                    })
                }
                TSproductUpdate.push(
                    {old: 
                        {
                            id:reserv[card.box_id][idx].id, 
                            countProduct:reserv[card.box_id][idx].countProduct, 
                            countEtimated:reserv[card.box_id][idx].countEtimated,
                            countProductHist:reserv[card.box_id][idx].countProductHist, 
                            package:reserv[card.box_id][idx].package || [],
                            consumes:reserv[card.box_id][idx].consumes || [],
                            addit_cons:reserv[card.box_id][idx].addit_cons || []
                        },
                    new:
                        {
                            id:tmp[card.box_id][idx].id, 
                            countProduct:tmp[card.box_id][idx].countProduct, 
                            countEtimated:tmp[card.box_id][idx].countEtimated,
                            countProductHist:tmp[card.box_id][idx].countProductHist, 
                            package:tmp[card.box_id][idx].package || [],
                            consumes:tmp[card.box_id][idx].consumes || [],
                            addit_cons:tmp[card.box_id][idx].addit_cons || []
                        }
                    }
                )
            }
            let tmpPack = undefined
            //Считаем значения расходников для товара, который добавляется в короб
            if (tmp[card.box_id][idx].package) {
                tmpPack = JSON.parse(JSON.stringify(tmp[card.box_id][idx].package))
                Object.keys(needAddToFromDealPackage).map((k) => {
                    let npidx = tmpPack.findIndex((fel) => fel.id === Number(k))
                    if (npidx > -1) {
                        tmpPack[npidx].fromDeal = needAddToFromDealPackage[k]
                    }
                })
            }
            
            let tmpConsum = undefined
            if (tmp[card.box_id][idx].consumes) {
                tmpConsum = JSON.parse(JSON.stringify(tmp[card.box_id][idx].consumes))
                Object.keys(needAddToFromDealConsumes).map((k) => {
                    let npidx = tmpConsum.findIndex((fel) => fel.id === Number(k))
                    if (npidx > -1) {
                        tmpConsum[npidx].fromDeal = needAddToFromDealConsumes[k]
                    }
                })
            }

            let tmpAdditConsum = undefined
            if (tmp[card.box_id][idx].addit_cons) {
                tmpAdditConsum = JSON.parse(JSON.stringify(tmp[card.box_id][idx].addit_cons))
                Object.keys(needAddToFromDealAdditConsumes).map((k) => {
                    let npidx = tmpAdditConsum.findIndex((fel) => fel.id === Number(k))
                    if (npidx > -1) {
                        tmpAdditConsum[npidx].fromDeal = needAddToFromDealAdditConsumes[k]
                    }
                })
            }
            ///

            ///Если товар надо удалить, то делаем это
            if (del) {tmp[card.box_id] = tmp[card.box_id].filter((el) => el.id !== card.id)}

            if (Object.keys(tmp).includes(""+$selBox)) {
                idx = tmp[$selBox].findIndex((el) => el.nmID === card.nmID && el.size.barcode === card.size.barcode)
                if (idx >-1) {
                    //в этом коробе уже есть такой же товар
                    tmp[$selBox][idx].countProduct = parseInt(tmp[$selBox][idx].countProduct) + parseInt(card.countProduct)
                    tmp[$selBox][idx].countEtimated = parseInt(tmp[$selBox][idx].countEtimated) + parseInt(card.countProduct) + ECBuf
                    tmp[$selBox][idx].countProductHist = parseInt(tmp[$selBox][idx].countProductHist) + parseInt(card.countProduct)

                    //для расходников
                    if (tmp[$selBox][idx].package) {
                        tmp[$selBox][idx].package.map((cons) => {
                            let npidx = tmpPack.findIndex((fel) => fel.id === cons.id)
                            cons.fromDeal = mergeConsumFromDealArrays(tmpPack[npidx].fromDeal, cons.fromDeal)
                        })
                    }
                    if (tmp[$selBox][idx].consumes) {
                        tmp[$selBox][idx].consumes.map((cons) => {
                            let npidx = tmpConsum.findIndex((fel) => fel.id === cons.id)
                            cons.fromDeal = mergeConsumFromDealArrays(tmpConsum[npidx].fromDeal, cons.fromDeal)
                        })
                    }
                    if (tmp[$selBox][idx].addit_cons) {
                        tmp[$selBox][idx].addit_cons.map((cons) => {
                            let npidx = tmpAdditConsum.findIndex((fel) => fel.id === cons.id)
                            cons.fromDeal = mergeConsumFromDealArrays(tmpAdditConsum[npidx].fromDeal, cons.fromDeal)
                        })
                    }
                    ////

                    TSproductUpdate.push(
                        {
                        old:
                            {
                                id:reserv[$selBox][idx].id, 
                                countProduct:reserv[$selBox][idx].countProduct, 
                                countEtimated:reserv[$selBox][idx].countEtimated,
                                countProductHist:reserv[$selBox][idx].countProductHist, 
                                package:reserv[$selBox][idx].package || [],
                                consumes:reserv[$selBox][idx].consumes || [],
                                addit_cons:reserv[$selBox][idx].addit_cons || []
                            },
                        new:
                            {
                                id:tmp[$selBox][idx].id, 
                                countProduct:tmp[$selBox][idx].countProduct, 
                                countEtimated:tmp[$selBox][idx].countEtimated,
                                countProductHist:tmp[$selBox][idx].countProductHist, 
                                package:tmp[$selBox][idx].package || [],
                                consumes:tmp[$selBox][idx].consumes || [],
                                addit_cons:tmp[$selBox][idx].addit_cons || []
                            }   
                        }
                    )
                    targetBox.count += parseInt(card.countProduct)
                    // post('Boxes/update', {id:targetBox.id, count:targetBox.count})
                    TSboxUpdate.push(targetBox.id)
                }
                //в этом коробе ранее не было такого товара
                else {
                    let obj = {...card, 
                        box_id: $selBox, 
                        countEtimated: card.countProduct + ECBuf,
                        countProductHist: card.countProduct,
                        package:tmpPack || [],
                        consumes:tmpConsum || [],
                        addit_cons:tmpAdditConsum || []
                    }
                    delete obj.id
                    delete obj.data
                    let nc = await post("products/create", obj)
                    if (nc.id) {
                        tmp[$selBox].push(
                            {
                                ...card, 
                                box_id: $selBox, 
                                id: nc?.id || undefined,
                                countEtimated: card.countProduct + ECBuf,
                                countProductHist: card.countProduct,
                                package:tmpPack || [],
                                consumes:tmpConsum || [],
                                addit_cons:tmpAdditConsum || []
                            }
                        )
                        targetBox.count += parseInt(card.countProduct)
                        targetBox.sku += 1
                        // post('Boxes/update', {id:targetBox.id, sku: targetBox.sku, count:targetBox.count})
                        TSboxUpdate.push(targetBox.id)
                        TSCreatedProducts.push(nc.id)
                    }
                    else {
                        GlobalErr = true
                        break
                    }
                    
                }
            }
            //Ранее короб не заполнялся
            else {
                let obj = {...card, 
                    box_id: $selBox, 
                    countEtimated: card.countProduct + ECBuf,
                    countProductHist: card.countProduct,
                    package:tmpPack || [],
                    consumes:tmpConsum || [],
                    addit_cons:tmpAdditConsum || []
                }
                delete obj.id
                delete obj.data
                let nc = await post("products/create", obj)
                if (nc.id) {
                    tmp[$selBox] = [
                        {
                            ...card, 
                            box_id: $selBox, 
                            id: nc?.id || undefined,
                            countEtimated: card.countProduct + ECBuf,
                            countProductHist: card.countProduct,
                            package:tmpPack || [],
                            consumes:tmpConsum || [],
                            addit_cons:tmpAdditConsum || []
                        }
                    ]
                    targetBox.count += parseInt(card.countProduct)
                    targetBox.sku += 1
                    // post('Boxes/update', {id:targetBox.id, sku: targetBox.sku, count:targetBox.count})
                    TSboxUpdate.push(targetBox.id)
                    TSCreatedProducts.push(nc.id)
                }
                else {
                    GlobalErr = true
                    break
                }
                
            }
            const oldBox = boxes.find((b) => b.id === $selBox)?.title || "Неизвестный короб"

            logsData.push(
                {
                    nmID: card.nmID,
                    barcode: card.data.barcode,
                    title: card.data.title,
                    count: card.countProduct,
                    vendorCode: card.vendorCode,
                    oldBox: oldBox
                }
            )
        }

        //Выносим серверную часть отдельно, мониторим каждое действие
        //Проверяем на наличие ошибок при создании
        if (GlobalErr) {
            //Если во время создания возникли ошибки, то нужно откатить созданные товары
            if (TSCreatedProducts.length > 0) {
                await post("products/delete", TSCreatedProducts)
            }
            showNotification({
                id: 'ErrorAddProduc', 
                type: 'error', 
                message: 'Ошибка при добавлении товаров'
            });
            let btmp = JSON.parse(JSON.stringify(boxes))
            return {data:reserv, boxes:btmp}
        }
        //Если ранее ошибки не было
        else {
            //Сначала нужно пройтись по товарам, которые нужно обновить
            // await Promise.all(TSproductUpdate.map(async (el) => {
            //     let resp = await post("products/update", el.new)
            //     if (resp.message !== 'ok') {
            //         GlobalErr = true
            //     }
            // }))
            let resp = await post("products/updateList", {list: TSproductUpdate.map((el) => el.new)})
            if (resp.message !== 'ok') {
                GlobalErr = true
            }
            //Если возникла глобальная ошибка, то нужно откатить обновлнения
            if (GlobalErr) {
                await Promise.all(TSproductUpdate.map(async (el) => {
                    await post("products/update", el.old)
                })) 
                showNotification({
                    id: 'ErrorAddProduc', 
                    type: 'error', 
                    message: 'Ошибка при добавлении товаров'
                });
                let btmp = JSON.parse(JSON.stringify(boxes))
                return {data:reserv, boxes:btmp}
            }
            else {
                //Если все ок, то действуем дальше
                await post('Boxes/recalcProductsMany', {bids:TSboxUpdate})

                let boxidx = boxes.findIndex((fel) => fel.id === $selBox)
                let logBox = undefined
                if (boxidx > -1) {
                    logBox = boxes[boxidx].title
                }
                console.log('FIND DATA', logsData)
                await post("Logs/create", {
                    deal_id,
                    user_type:"ful",
                    user_id,
                    type: "move_to_box",
                    data: {
                        products: logsData,
                        box:logBox || targetBox?.title || $selBox
                    }
                })
                console.log("TMP", tmp)
                let btmp = JSON.parse(JSON.stringify(boxes))
                let bidx = btmp.findIndex((el) => el.id === targetBox.id)
                console.log("bidx", bidx)
                if (bidx > -1) {btmp[bidx] = targetBox} else{btmp.push(targetBox)}
                return {data:tmp, boxes:btmp}
            }
        }
    }

    const onAddProduct = async (products, box=undefined) => {
        setScrollPosition()
        console.log("products", products)
        console.log("box", box)
        // @ts-ignore
        let $selBox = box? box.id: selBox
        let targetBox = box? JSON.parse(JSON.stringify(box)): JSON.parse(JSON.stringify(boxes)).find((el) => el.id === $selBox)
        if (!$selBox || !targetBox) { 
            showNotification({
                id: 'ErrorAddProduc', 
                type: 'error', 
                message: 'Ошибка добавления товара' 
            });
            return
        }
        setLoading(true)
        setDOpen(false)
        //Делаем небольшой трюк и сначала добавляем эти товары в нулевой короб
        await post('Deal/addProductsToDeal', {list: products, deal_id, replace: false, user_id})
        
        //После этого перезапрашиваем товары в сделке
        let updatedData = await get("Deal/GetProductsWithBoxOnDeal", {did:deal_id})
        let result = {}
        for (let card of updatedData) {
            let obj = {
                ...card,
                data: {
                    market:market,
                    vendorCode:card.vendorCode,
                    brand:card.brand,
                    title:card.title,
                    photo:card.photo,
                    color:card.color,
                    dimensions: card.dimensions,
                    material:card.material,
                    barcode:card.size.barcode,
                    sizeTitle:card.size.title,
                    url: card.size.url,
                    nmID: card.size?.ozonID || card.nmID
                },
            }
            if (Object.keys(result).includes(""+card.box_id)) {
                result[card.box_id].push(obj)
            }
            else {result[card.box_id] = [{...obj}]}
        }
        Object.keys(result).forEach(boxId => {
            result[boxId].sort((a, b) => {
                const barcodeA = String(a.data.barcode || '');
                const barcodeB = String(b.data.barcode || '');
                
                // Сначала сортируем по баркоду товара
                if (barcodeA !== barcodeB) {
                    return barcodeA.localeCompare(barcodeB);
                }
                
                // Если баркоды совпадают, сортируем по id для абсолютной стабильности
                return (a.id || 0) - (b.id || 0);
            });
        });

        console.log("tmp", JSON.parse(JSON.stringify(result)))
        let rightProducts = []
        //Теперь нужно получить реальные id товаров, которые были добавленны
        for (let el of products) {
            let tmpPR = JSON.parse(JSON.stringify(result[0].find((fel) => fel.size.barcode === el.size.barcode)))
            tmpPR.countProduct = el.countProduct
            rightProducts.push(tmpPR)
        }

        //А уже после, привязываем товары в короб
        let tmp = JSON.parse(JSON.stringify(result))
        console.log("rightProducts", rightProducts)
        let res = await addProductCalc($selBox, targetBox, rightProducts, tmp)
        console.log("res.data", res.data)
        let toHist = []
        for (let el of rightProducts){
            console.log("CP", el.countProduct)
            toHist.push({actionType: "productToBox", type, barcode: el.size.barcode, box: targetBox, count: el.countProduct})
        }
        addToHistory(toHist)
        setData(res.data)
        setBoxes(boxSort(res.boxes))
        setLoading(false)
        showNotification({
            id: 'SuccessAddProduc', 
            type: 'success', 
            message: 'Товар успешно добавлен'
        });
    }


    const openAddProduct = (bid) => {
        setSelBox(bid)
        setDOpen(true)
    }
    

    const addBox = async (boxCount = undefined, boxTitles = undefined, type = 'box', parent_id = undefined) => {
        setScrollPosition()
        // setLoading(true) 
        
        let res = []
        let $addBoxCount = boxCount || (type === "box" ? addBoxCount : addPalletCount)
        
        for (let i = 1; i <= $addBoxCount; i++) {
            let BN = undefined
            if (boxTitles) {
                BN = boxTitles[i-1]
            } else {
                let tmpboxex = JSON.parse(JSON.stringify(boxes)).filter((fel) => fel.type === type && fel.title.startsWith(`С${dealNumber}`))
                if (tmpboxex.length > 0) {
                    let idx = tmpboxex.sort((a, b) => (parseInt(b.title.slice(b.title.lastIndexOf(type === 'box'? 'К': "П")+1)) - parseInt(a.title.slice(a.title.lastIndexOf(type === 'box'? 'К': "П")+1))))[0]?.title.lastIndexOf(type === 'box'? 'К': "П") || -1
                    if (idx > -1) {
                        let s = tmpboxex[0].title.slice(idx+1)
                        BN = parseInt(s)+i
                    } else { BN = 1 }
                } else {
                    BN = i
                }
            }   

            let nb = await post("Boxes/create", {deal_id, title: `С${dealNumber}_к${cliID}_${type === 'box'? 'К': "П"}${BN}`, sku: 0, count:0, box_count:0, type, parent_id})

            if (nb.message.id) {
                res.push({
                    ...nb.message,
                    open: false,
                    openMenu: null,
                    openSelectPallet: null
                })
            }
            else {
                console.log(nb.message)
                showNotification({
                    id: 'addFail', 
                    type: 'error', 
                    message: `Ошибка создания С${dealNumber}_к${cliID}_${type === 'box'? 'К': "П"}${BN}` 
                });
            }

        }   
        if (res.length > 0 ) {
            let tmp = JSON.parse(JSON.stringify(boxes))
        
            // Пересчет количества привязанных коробов
            if (parent_id) {
                let bc = await post("Boxes/recalcBoxCount", {bid:parent_id})
                let idx = tmp.findIndex((el) => el.id === parent_id)
                tmp[idx].box_count = bc.count
            }
            
            const newBoxes = boxSort(tmp.concat(res));
            
            setBoxes(newBoxes)
            showNotification({
                id: 'addSuccess', 
                type: 'success', 
                message: `${type === 'box'? "Короб": "Паллет"} успешно создан` 
            });
        }
        return res;
    }
    

    const save = async (inchanged = undefined) => {
        setScrollPosition()
        setLoading(true)
        let tmp = JSON.parse(JSON.stringify(data))
        console.log("tmp", tmp)
        let Btmp = [...boxes]
        let changedList = inchanged || changed
        console.log("changedList", changedList)
        let logsData = []
        let changedBoxes = []
        for (let card of changedList) {
            // console.log("card", card)
            let idx = tmp[card.box].findIndex((el) => el.id === card.id)

            let bidx = Btmp.findIndex((el) => el.id === card.box)
            if (!changedBoxes.includes(card.box)) {changedBoxes.push(card.box)}

            let needAddToFromDealPackage = {}
            let needAddToFromDealConsumes = {}
            let needAddToFromDealAdditConsumes = {}
            if (idx >- 1) {
                //Увеличение
                if (tmp[card.box][idx].countProduct <= card.count) {
                    // card.count = tmp[card.box][idx].countProduct
                    let addErr = false
                    if (tmp[0]) {
                        let nulIdx = tmp[0].findIndex((el) => el.size.barcode === tmp[card.box][idx].size.barcode)
                        console.log("nulidx", nulIdx)
                        if (nulIdx > -1) {
                            console.log("fff", tmp[0][nulIdx].countProduct, card.count-tmp[card.box][idx].countProduct)
                            if (tmp[0][nulIdx].countProduct >= card.count-tmp[card.box][idx].countProduct)//Далем вычитание, чтобы понимать именно разницу
                            {
                                // await onAddProduct([{...tmp[0][nulIdx], countProduct: card.count-tmp[card.box][idx].countProduct}], Btmp[bidx])
                                let addRes = await addProductCalc(Btmp[bidx].id, Btmp[bidx], [{...tmp[0][nulIdx], countProduct: card.count-tmp[card.box][idx].countProduct}], tmp)
                                tmp = addRes.data
                                Btmp = addRes.boxes
                            }
                            else {addErr = true}
                        }
                        else {addErr = true}
                    }
                    else {addErr = true}
                    if (addErr) {
                        card.count = tmp[card.box][idx].countProduct
                        showNotification({
                            id: 'dontCanAddMoreProduct',
                            type: 'warning', 
                            message: `Недостаточно нераспределенного товара ${tmp[card.box][idx].size.barcode}` 
                        });
                    }   

                }
                else {
                    ///Инфа для логов
                    const oldBox = Btmp.find((b) => b.id === card.box)?.title || "Неизвестный короб"
                    logsData.push(
                        {
                            nmID: tmp[card.box][idx].nmID,
                            barcode: tmp[card.box][idx].data.barcode,
                            title: tmp[card.box][idx].data.title,
                            count: parseInt(tmp[card.box][idx].countProduct) - card.count,
                            vendorCode: tmp[card.box][idx].vendorCode,
                            oldBox: oldBox
                        }
                    )

                    ///тут по образу и подобию прибавления, считаем вычитание
                    //todo есть смысл потом переписать для оптимизации
                    //Для упаковки
                    if (tmp[card.box][idx].package) {
                        tmp[card.box][idx].package.map((cons) => {
                            if (cons.fromDeal) {
                                let consumNeedCountDel = cons.count * (tmp[card.box][idx].countProduct - card.count)
                                if (!needAddToFromDealPackage[cons.id]) {
                                    needAddToFromDealPackage[cons.id] = []
                                }
                                cons.fromDeal.map((ofd) => {
                                    if (consumNeedCountDel > 0) {
                                        if (ofd.count >= consumNeedCountDel) {
                                            let fdtmp = {deal:ofd.deal, count:consumNeedCountDel}
                                            if (ofd.box) {fdtmp.box = ofd.box}
                                            needAddToFromDealPackage[cons.id].push(fdtmp)
                                        }
                                        else {
                                            if (ofd.count > 0) {
                                                let fdtmp = {deal:ofd.deal, count:ofd.count}
                                                if (ofd.box) {fdtmp.box = ofd.box}
                                                needAddToFromDealPackage[cons.id].push(fdtmp)
                                            }
                                        }
                                    }
                                })
                            }
                        })
                    }
                    //Для комплектации
                    if (tmp[card.box][idx].consumes) {
                        tmp[card.box][idx].consumes.map((cons) => {
                            if (cons.fromDeal) {
                                let consumNeedCountDel = cons.count * (tmp[card.box][idx].countProduct - card.count)
                                if (!needAddToFromDealConsumes[cons.id]) {
                                    needAddToFromDealConsumes[cons.id] = []
                                }
                                cons.fromDeal.map((ofd) => {
                                    if (ofd.count >= consumNeedCountDel) {
                                        let fdtmp = {deal:ofd.deal, count:consumNeedCountDel}
                                        if (ofd.box) {fdtmp.box = ofd.box}
                                        needAddToFromDealConsumes[cons.id].push(fdtmp)
                                    }
                                    else {
                                        if (ofd.count > 0) {
                                            let fdtmp = {deal:ofd.deal, count:ofd.count}
                                            if (ofd.box) {fdtmp.box = ofd.box}
                                            needAddToFromDealConsumes[cons.id].push(fdtmp)
                                        }
                                    }
                                })
                            }
                        })
                    }
                    //Для расходников
                    if (tmp[card.box][idx].addit_cons) {
                        tmp[card.box][idx].addit_cons.map((cons) => {
                            if (cons.fromDeal) {
                                let consumNeedCountDel = cons.count * (tmp[card.box][idx].countProduct - card.count)
                                if (!needAddToFromDealAdditConsumes[cons.id]) {
                                    needAddToFromDealAdditConsumes[cons.id] = []
                                }
                                cons.fromDeal.map((ofd) => {
                                    if (ofd.count >= consumNeedCountDel) {
                                        let fdtmp = {deal:ofd.deal, count:consumNeedCountDel}
                                        if (ofd.box) {fdtmp.box = ofd.box}
                                        needAddToFromDealAdditConsumes[cons.id].push(fdtmp)
                                    }
                                    else {
                                        if (ofd.count > 0) {
                                            let fdtmp = {deal:ofd.deal, count:ofd.count}
                                            if (ofd.box) {fdtmp.box = ofd.box}
                                            needAddToFromDealAdditConsumes[cons.id].push(fdtmp)
                                        }
                                    }
                                })
                            }
                        })
                    }
                    //Считаем значения расходников для товара, который добавляется в короб
                    let tmpPack = JSON.parse(JSON.stringify(tmp[card.box][idx].package))
                    Object.keys(needAddToFromDealPackage).map((k) => {
                        let npidx = tmpPack.findIndex((fel) => fel.id === Number(k))
                        if (npidx > -1) {
                            tmpPack[npidx].fromDeal = needAddToFromDealPackage[k]
                        }
                    })
                    
                    let tmpConsum = JSON.parse(JSON.stringify(tmp[card.box][idx].consumes))
                    Object.keys(needAddToFromDealConsumes).map((k) => {
                        let npidx = tmpConsum.findIndex((fel) => fel.id === Number(k))
                        if (npidx > -1) {
                            tmpConsum[npidx].fromDeal = needAddToFromDealConsumes[k]
                        }
                    })

                    let tmpAdditConsum = JSON.parse(JSON.stringify(tmp[card.box][idx].addit_cons))
                    Object.keys(needAddToFromDealAdditConsumes).map((k) => {
                        let npidx = tmpAdditConsum.findIndex((fel) => fel.id === Number(k))
                        if (npidx > -1) {
                            tmpAdditConsum[npidx].fromDeal = needAddToFromDealAdditConsumes[k]
                        }
                    })

                    if (Object.keys(tmp).includes("0")) {
                        //Если нулевой короб уже есть
                        let idx2 = tmp[0].findIndex((el) => el.nmID === tmp[card.box][idx].nmID && el.size.barcode === tmp[card.box][idx].size.barcode)
                        if (idx2 >-1) {
                            //в нулевом коробе уже есть такой же товар
                            tmp[0][idx2].countProduct = parseInt(tmp[0][idx2].countProduct) + (parseInt(tmp[card.box][idx].countProduct) - card.count)
                            tmp[0][idx2].countEtimated = parseInt(tmp[0][idx2].countEtimated) + (parseInt(tmp[card.box][idx].countEtimated) - card.count)
                            tmp[0][idx2].countProductHist = parseInt(tmp[0][idx2].countProductHist) + (parseInt(tmp[card.box][idx].countProductHist) - card.count)

                            //для расходников
                            tmp[0][idx2].package.map((cons) => {
                                let npidx = tmpPack.findIndex((fel) => fel.id === cons.id)
                                cons.fromDeal = mergeConsumFromDealArrays(tmpPack[npidx].fromDeal, cons.fromDeal)
                            })
                            tmp[0][idx2].consumes.map((cons) => {
                                let npidx = tmpConsum.findIndex((fel) => fel.id === cons.id)
                                cons.fromDeal = mergeConsumFromDealArrays(tmpConsum[npidx].fromDeal, cons.fromDeal)
                            })
                            tmp[0][idx2].addit_cons.map((cons) => {
                                let npidx = tmpAdditConsum.findIndex((fel) => fel.id === cons.id)
                                cons.fromDeal = mergeConsumFromDealArrays(tmpAdditConsum[npidx].fromDeal, cons.fromDeal)
                            })
                            ////
                            console.log("AAAAAAAAAAAAAAA", tmp[0][idx2])
                            await post("products/update", {
                                id:tmp[0][idx2].id, 
                                countProduct:tmp[0][idx2].countProduct,
                                countProductHist:tmp[0][idx2].countProductHist,
                                countEtimated:tmp[0][idx2].countEtimated,
                                package:tmp[0][idx2].package,
                                consumes:tmp[0][idx2].consumes,
                                addit_cons:tmp[0][idx2].addit_cons
                            })
                        }
                        //в 0 коробе ранее не было такого товара
                        else {
                            let obj = {...tmp[card.box][idx], 
                                box_id: 0, 
                                countProduct: parseInt(tmp[card.box][idx].countProduct) - card.count,
                                countEtimated: parseInt(tmp[card.box][idx].countEtimated) - card.count,
                                countProductHist: parseInt(tmp[card.box][idx].countProductHist) - card.count,
                                package:tmpPack,
                                consumes:tmpConsum,
                                addit_cons:tmpAdditConsum
                            }
                            delete obj.id
                            delete obj.data
                            let nc = await post("products/create", obj)
                            if (nc.id) {
                                tmp[0].push({...tmp[card.box][idx], 
                                    box_id: 0, 
                                    countProduct: parseInt(tmp[card.box][idx].countProduct) - card.count, 
                                    countEtimated: parseInt(tmp[card.box][idx].countEtimated) - card.count,
                                    countProductHist: parseInt(tmp[card.box][idx].countProductHist) - card.count, 
                                    package:tmpPack,
                                    consumes:tmpConsum,
                                    addit_cons:tmpAdditConsum,
                                    id: nc?.id
                                })
                            }
                            
                        }
                    }
                    else {
                        //елс нулевого короба еще нет
                        let obj = {...tmp[card.box][idx], 
                            box_id: 0, 
                            countProduct: parseInt(tmp[card.box][idx].countProduct) - card.count,
                            countEtimated:parseInt(tmp[card.box][idx].countEtimated) - card.count,
                            countProductHist: parseInt(tmp[card.box][idx].countProductHist) - card.count,
                            package:tmpPack,
                            consumes:tmpConsum,
                            addit_cons:tmpAdditConsum
                        }
                        delete obj.id
                        delete obj.data
                        let nc = await post("products/create", obj)
                        if (nc.id) {
                            tmp[0] = [{...tmp[card.box][idx], 
                                box_id: 0, 
                                countProduct: parseInt(tmp[card.box][idx].countProduct) - card.count,
                                countEtimated:parseInt(tmp[card.box][idx].countEtimated) - card.count,
                                countProductHist: parseInt(tmp[card.box][idx].countProductHist) - card.count,
                                package:tmpPack,
                                consumes:tmpConsum,
                                addit_cons:tmpAdditConsum,
                                id: nc?.id
                            }]
                        }
                    }


                    if (parseInt(card.count) > 0) {
                        //после изменения товара он еще остается в коробе
                        if (bidx>-1) {                            
                            Btmp[bidx].count -= parseInt(tmp[card.box][idx].countProduct) - parseInt(card.count)
                            // await post('Boxes/update', {id:Btmp[bidx].id, count:Btmp[bidx].count})
                        }
                        //Тут нам надо посчитать сколько расходников останется
                        //Для упаковки
                        if (tmp[card.box][idx].package) {
                            tmp[card.box][idx].package.map((cons) => {
                                if (cons.fromDeal) {
                                    let consumNeedCountDel = cons.count * (tmp[card.box][idx].countProduct - card.count)
                                    cons.fromDeal.map((ofd) => {
                                        if (consumNeedCountDel > 0) {
                                            if (ofd.count >= consumNeedCountDel) {
                                                ofd.count = ofd.count - consumNeedCountDel
                                                consumNeedCountDel = 0
                                            }
                                            else {
                                                if (ofd.count > 0) {
                                                    consumNeedCountDel = consumNeedCountDel - ofd.count
                                                    ofd.count = 0
                                                }
                                            }
                                        }
                                    })
                                }
                            })
                        }
                        //Для комплектации
                        if (tmp[card.box][idx].consumes) {
                            tmp[card.box][idx].consumes.map((cons) => {
                                if (cons.fromDeal) {
                                    let consumNeedCountDel = cons.count * (tmp[card.box][idx].countProduct - card.count)
                                    cons.fromDeal.map((ofd) => {
                                        if (ofd.count >= consumNeedCountDel) {
                                            ofd.count = ofd.count - consumNeedCountDel
                                            consumNeedCountDel = 0
                                        }
                                        else {
                                            if (ofd.count > 0) {
                                                consumNeedCountDel = consumNeedCountDel - ofd.count
                                                ofd.count = 0
                                            }
                                        }
                                    })
                                }
                            })
                        }
                        //Для расходников
                        if (tmp[card.box][idx].addit_cons) {
                            tmp[card.box][idx].addit_cons.map((cons) => {
                                if (cons.fromDeal) {
                                    let consumNeedCountDel = cons.count * (tmp[card.box][idx].countProduct - card.count)
                                    cons.fromDeal.map((ofd) => {
                                        if (ofd.count >= consumNeedCountDel) {
                                            ofd.count = ofd.count - consumNeedCountDel
                                            consumNeedCountDel = 0
                                        }
                                        else {
                                            if (ofd.count > 0) {
                                                consumNeedCountDel = consumNeedCountDel - ofd.count
                                                ofd.count = 0
                                            }
                                        }
                                    })
                                }
                            })
                        }
                        ///
                        tmp[card.box][idx].countProduct = parseInt(card.count)
                        tmp[card.box][idx].countEtimated = parseInt(card.count)
                        tmp[card.box][idx].countProductHist = parseInt(card.count)
                        await post("products/update", {
                            id:tmp[card.box][idx].id, 
                            countProduct:tmp[card.box][idx].countProduct,
                            countEtimated:tmp[card.box][idx].countEtimated,
                            countProductHist:tmp[card.box][idx].countProductHist,
                            package:tmp[card.box][idx].package,
                            consumes:tmp[card.box][idx].consumes,
                            addit_cons:tmp[card.box][idx].addit_cons
                        })
                    }                
                    else {
                        //после изменения товара в коробе не осталось
                        if (bidx>-1) {
                            Btmp[bidx].count -= parseInt(tmp[card.box][idx].countProduct)
                            Btmp[bidx].sku -= 1
                            // post('Boxes/update', {id:Btmp[bidx].id, sku: Btmp[bidx].sku, count:Btmp[bidx].count})
                            // await post("Boxes/recalcProducts", {bid: Btmp[bidx].id})
                        }
                        await post("products/delete", [card.id])
                        tmp[card.box] = tmp[card.box].filter((el) => el.id !== card.id)
                        
                    }
                }
            }
        }
        await post("Boxes/recalcProductsMany", {bids: changedBoxes})
        setData(tmp)
        setBoxes(boxSort(Btmp))
        if (logsData.length > 0){
            post("Logs/create", {
                deal_id,
                user_type:"ful",
                user_id,
                type: "move_to_box",
                data: {
                    products: logsData,
                    box: "Нераспределенный товар"
                }
            })
        }
        console.log("SAVE", tmp)
        if (!inchanged) {setChanged([])} else {
            //Так можно сделать, ибо inchanged хоть и массив, но только из 1 элемента
            // @ts-ignore
            let tmpChanged = JSON.parse(JSON.stringify(changed)).filter((el) => el.id != inchanged[0].id) 
            console.log("tmpChanged", tmpChanged)
            setChanged(tmpChanged)
        }
        setLoading(false)
    }

    useEffect(() => {

        const cancelAction = async (list) => {
            setLoading(true)
            for (let item of list) {
                switch (item.actionType) {
                    case "productToBox": {

                        //Считаем, сколько всего сейчас товара
                        let count = 0
                        for(let k of Object.keys(data)) {
                            let subidx = data[k].findIndex((fel) => fel.size.barcode === item.barcode)
                            
                            if (subidx > -1) {
                                console.log("F", k, data[k][subidx].countProduct)
                                count += data[k][subidx].countProduct
                            }
                        }
                        console.log("AAA", count)
                        console.log("AAADATA", data)
                        let idx = data[item.box.id].findIndex((fel) => fel.size.barcode === item.barcode)
                        
                        // @ts-ignore
                        await save([{ box: item.box.id, id: data[item.box.id][idx].id, count: data[item.box.id][idx].countProduct - item.count}])//Сколько должно остаться
                        //Дата после этого автоматически обновлена
                        //Но теперь нужно удалить еще и из нулевого короба
                        await post("Deal/updateOnNmAndSize", {
                            user_id: user_id,
                            nmID: data[item.box.id][idx].nmID, 
                            deal_id,
                            barcode: item.barcode,
                            countProduct: count - item.count,
                        })
                        //Для верности обновляюм дату
                        let updatedData = await get("Deal/GetProductsWithBoxOnDeal", {did:deal_id})
                        let result = {}
                        for (let card of updatedData) {
                            let obj = {
                                ...card,
                                data: {
                                    market:market,
                                    vendorCode:card.vendorCode,
                                    brand:card.brand,
                                    title:card.title,
                                    photo:card.photo,
                                    color:card.color,
                                    dimensions: card.dimensions,
                                    material:card.material,
                                    barcode:card.size.barcode,
                                    sizeTitle:card.size.title,
                                    url: card.size.url,
                                    nmID: card.size?.ozonID || card.nmID
                                },
                            }
                            if (Object.keys(result).includes(""+card.box_id)) {
                                result[card.box_id].push(obj)
                            }
                            else {result[card.box_id] = [{...obj}]}
                        }
                        Object.keys(result).forEach(boxId => {
                            result[boxId].sort((a, b) => {
                                const barcodeA = String(a.data.barcode || '');
                                const barcodeB = String(b.data.barcode || '');
                                
                                // Сначала сортируем по баркоду товара
                                if (barcodeA !== barcodeB) {
                                    return barcodeA.localeCompare(barcodeB);
                                }
                                
                                // Если баркоды совпадают, сортируем по id для абсолютной стабильности
                                return (a.id || 0) - (b.id || 0);
                            });
                        });
                        setData(result)
                        //Очищаем лист
                        clearCancelList()
                        break
                    }
                }
            }
            setLoading(false)
        }

        if (cancelList) {
            cancelAction(cancelList)
        }
    }, [cancelList]); 

    /** @type {any} */
    let scrollRef = useRef(null)

    const [scroll, setScroll] = useState(0);

    const setScrollPosition = () => {
        if (scrollRef.current) {
            const values = scrollRef.current.getValues();
            setScroll(values.scrollTop)
            return values.scrollTop;
        }
        return 0;
    };

    useEffect(() => {
        console.log("scroll", scroll)
        if (scrollRef.current && scroll > 0) {
            scrollRef.current.scrollTop(scroll)
        }
    }, [data, boxes]); 

    const { socket } = useContext(SocketContext);

    const handleIdSort = () => {
        const nextOrder = idSortOrder === 'asc' ? 'desc' : 'asc';
        setIdSortOrder(nextOrder);
        
        // Сохраняем в localStorage
        localStorage.setItem('bindDeal_sortOrder', nextOrder);

        setBoxes(boxSort([...boxes]))
    };
    

    useEffect(() => {
        let tmp = [...boxes]
        tmp.map((el) => el.open = false)
        if (checked) {
            let tmpFinded = []
            tmp.map((el, index) => {
                if (data[el.id]) {
                    console.log(data[el.id])
                    let idx = data[el.id].findIndex((el) => {
                        const tf = filter.toLowerCase();
                        return (
                        filterFields.title.active &&
                            el.data.title &&
                            String(el.data.title).toLowerCase().includes(tf) ||
                        filterFields.brand.active &&
                            el.data.brand &&
                            String(el.data.brand).toLowerCase().includes(tf) ||
                        filterFields.vendorCode.active &&
                            el.data.vendorCode &&
                            String(el.data.vendorCode).toLowerCase().includes(tf) ||
                        filterFields.color.active &&
                            el.data.color &&
                            el.data.color.join(" ").toLowerCase().includes(tf) ||
                        filterFields.size.active &&
                            el.size.ttle &&
                            String(el.size.title).toLowerCase().includes(tf) ||
                        filterFields.barcode.active &&
                            el.size.barcode &&
                            el.size.barcode.toLowerCase().includes(tf)
                        )
                    })
                    if (idx > -1) {
                        tmp[index].open = true
                        if (!tmpFinded.includes(data[el.id][idx].id)) {tmpFinded.push(data[el.id][idx].id)}
                        if (tmp[index].parent_id) {
                            let pidx = boxes.findIndex((fel)=> fel.id === tmp[index].parent_id)
                            tmp[pidx].open = true
                        }
                        else {
                            setNoPalletOpen(true)
                        }
                    }
                }
            })
            setFinded(tmpFinded)
        }
        else {
            setFinded([])
        }
        setBoxes(boxSort(tmp))
    }, [checked]); 


    const reculcSku = () => {
        let sku = []
        let count = 0
        let tmpPallets = {}
        Object.keys(data).filter((el) => el != "0").map((box) => {
            let boxObj = boxes.find((fel) => fel.id === Number(box))
            console.log("boxObj", boxObj)
            data[box].map((item) => {
                if (!sku.includes(item.data.barcode)) {sku.push(item.data.barcode)}
                count += parseInt(item.countProduct)
                if (boxObj?.parent_id) {
                    if (tmpPallets[boxObj.parent_id]) {
                        if (!tmpPallets[boxObj.parent_id].sku.includes(item.data.barcode)) {
                            tmpPallets[boxObj.parent_id].sku.push(item.data.barcode)
                        }
                        tmpPallets[boxObj.parent_id].count += item.countProduct
                    }
                    else {
                        tmpPallets[boxObj.parent_id] = {sku: [item.data.barcode], count: item.countProduct}
                    }
                }
            })
        })
        setAllSkuBinded(sku.length)
        setAllCountBinded(count)
        setInPalletCount(tmpPallets)
    }

    useEffect(() => {
        reculcSku()
    }, [data, boxes]);

    const PalletAddPopover = ({ parel, onAddBox, onAddProduct, blocked}) => {
        const [open, setOpen] = useState(false);
        const [anchorTPBP, setAnchorTPBP] = useState(null);
        const [addTPTypeBP, setAddTPTypeBP] = useState(false);
        const [addBoxCountLocal, setAddBoxCountLocal] = useState(1);

        const handleOpen = (event) => {
            event.stopPropagation();
            setAnchorTPBP(event.currentTarget);
            setOpen(true);
        };

        const handleClose = () => {
            setOpen(false);
            setAnchorTPBP(null);
            // сброс внутренних значений при закрытии (опционально)
            setAddTPTypeBP(false);
            setAddBoxCount(1);
        };

        const handleAdd = (event) => {
            event.stopPropagation();
            if (parel.box_count > 0) {
                onAddBox(parel.id, addBoxCountLocal);
            } else {
                if (!addTPTypeBP) onAddBox(parel.id,addBoxCountLocal);
                else onAddProduct(parel.id);
            }
            handleClose();
        };

        return (
            <>
            <Tooltip title={parel.box_count > 0 ? `Добавить короб${blocked? " (заблокировано в хранении)": ""}` : `Добавить короб/товар${blocked? " (заблокировано в хранении)": ""}`}>
                <IconButton onClick={handleOpen} sx={{ position: 'relative' }} >
                    <AddIcon sx={{ transition: 'all 0.3s ease', '&:hover': hoverStyle, color: parel.open ? 'white' : "black" }} />
                </IconButton>
            </Tooltip>

            <Popover
                open={open}
                anchorEl={anchorTPBP}
                onClose={handleClose}
                anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
                transformOrigin={{ vertical: 'top', horizontal: 'left' }}
                PaperProps={{ sx: { mt: 1, p: 1 } }}
            >
                <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1, minWidth: 160, alignItems: 'center' }}>
                {parel.box_count === 0 && (
                    <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
                        <FormControlLabel
                            label={undefined}
                            sx={{ padding: 0, margin: 0 }}
                            onClick={(e) => {e.stopPropagation();}}
                            control={
                            <BoxProductSwitch
                                defaultChecked={addTPTypeBP}
                                onChange={(e) => setAddTPTypeBP(e.target.checked)}
                            />
                            }
                        />
                    </div>
                )}
                <MuiInput
                    sx={{
                    ':after': { borderBottomColor: '#005b52' },
                    width: '120px',
                    fontSize: '12px',
                    textAlign: 'center',
                    '& input': { textAlign: 'center' }
                    }}
                    value={addBoxCountLocal}
                    size="medium"
                    disabled={addTPTypeBP && parel.box_count === 0}
                    onClick={(e) => {e.stopPropagation();}}
                    onChange={(event) => {
                        const val = event.target.value;
                        if (val === '') setAddBoxCountLocal(1);
                        else {
                            const num = parseInt(val, 10);
                            if (!isNaN(num)) setAddBoxCountLocal(num);
                        }
                    }}
                    inputProps={{ 'aria-labelledby': 'input-count' }}
                />
                <Button variant='text' onClick={(e) => {preventDoubleClick(handleAdd(e))}} sx={{ fontSize: '12px', borderRadius: '10px', height: '20px' }}>
                    Добавить
                </Button>
                </Box>
            </Popover>
            </>
        );
        };

    const productItem = (el, datael) => {
        return (
            <div key={`pritem${datael.id}`} style={{width: '48%', margin: "5px 1% 0px 1%", display: 'flex', flexDirection: 'column', backgroundColor: (finded || []).includes(datael.id)? 'rgba(189, 219, 221, 0.4)': "white"}}>
                <ProductMoreInfo value={datael.data}/>
                <div style={{width: '100%', display: 'flex', flexDirection: 'row', alignItems: 'center'}}>
                    <NumInputDesign 
                        title={"Количество"} 
                        val={changed.find((fel) => fel.id === datael.id)?.count || datael.countProduct}
                        onChange={() => {}}
                        editable={false}
                    />
                </div>
            </div>
        )
    }

    const toggleDrawer = () => {

        const changeToggle = () => {
            setOpenDealInfo(false)
        }


        if (!openDealInfo && unsavedChanges) {
            ShowModal(
                'Несохраненные изменения',
                <div>У вас есть несохраненные данные. Вы уверены, что хотите закрыть шторку?</div>,
                async () => {
                    setUnsavedChanges(false)
                    changeToggle();
                }
            );
            return;
        }
        changeToggle()
    };

    console.log('BOXES 00000000', boxes)
    console.log('data 00000000', data)
    console.log('finded 00000000', finded)

    return (
        <div  
            style={{
                display: "flex", 
                flexDirection: "column", 
                height: "calc(100% - 50px )", 
                width: '98%',
                backgroundColor: 'white', 
                borderRadius: "10px", 
                borderTopLeftRadius: type === "return"? "0px": "10px",
                paddingTop: "1%"
            }}>
            <Dialog
                open={dOpen}
                maxWidth='lg'
                PaperProps={{ sx: { borderRadius: "20px", p: "10px" } }}
                onClose={() => { setDOpen(false) }}
            >
                <div style={{ height: '620px', width: '1000px', padding: '12px', }}>
                    <AddProductsToBox cli={cliID} market={market} cancel={setDOpen} onSave={onAddProduct} type={type}></AddProductsToBox>
                </div>

            </Dialog>
            <Drawer
                anchor='right'
                open={openDealInfo}
                PaperProps={{
                    sx: { width: '35%' }
                }}
                onClose={toggleDrawer}
            >
                <ElementInfo 
                    ds={getDataSource('EIDealNoStatus')} 
                    data = {deal_id}
                    setChanged={(v) => setUnsavedChanges(v)}
                />
            </Drawer>
            <Card sx={{ borderRadius: 3, boxShadow: 0, width: "100%", height: "100%" }}>

                <div style={{ marginTop: "5px", marginLeft: "25px", marginRight: "15px", display: "flex", flexDirection: "row", alignItems: "center", justifyContent: "space-between" }}>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                        <Button
                            variant="text"
                            sx={{
                                color: '#078376',
                                fontWeight: 'bold',
                                textTransform: 'none',         
                                fontSize: "12pt",
                                borderRadius: "10px"
                            }}
                            onClick={() => { setOpenDealInfo(true) }}
                            >
                            Сделка {dealNumber}
                        </Button>
                        <Typography align='left' sx={{fontSize: "12pt"}}>
                            {allSkuBinded} SKU {allCountBinded} шт. {boxesCount} коробов
                        </Typography>
                        
                        <Tooltip title="Сортировать паллеты по ID">
                            <IconButton size="small" onClick={handleIdSort} sx={{ ml: 1 }} disableRipple>
                                {idSortOrder === 'asc' && <NorthIcon fontSize="small" color="primary" sx={{'&:hover': hoverStyle}}/>}
                                {idSortOrder === 'desc' && <SouthIcon fontSize="small" color="primary" sx={{'&:hover': hoverStyle}}/>}
                            </IconButton>
                        </Tooltip>
                    </Box>
                    <Tooltip title={`Добавить короба/паллеты`}>
                        <IconButton 
                            onClick={handleOpenBP}
                            sx={{ 
                                position: 'relative',
                                backgroundColor: "#078476",
                                borderRadius: '50%',
                                }}
                            
                            disableRipple
                        >
                            <AddIcon
                                sx={{
                                    color: 'white',
                                    transition: 'all 0.3s ease',
                                    position: 'relative',
                                    '&:hover': hoverStyle,
                                }}
                            />
                        </IconButton>
                    </Tooltip>
                    <Popover
                        open={openBP}
                        anchorEl={anchorBP}
                        onClose={handleCloseBP}
                        anchorOrigin={{
                            vertical: 'bottom',   // появляется снизу от кнопки
                            horizontal: 'left',   // выравнивание по левому краю (можно 'center')
                        }}
                        transformOrigin={{
                            vertical: 'top',      // верхний край окна привязан к anchorOrigin
                            horizontal: 'left',
                        }}
                        PaperProps={{
                            sx: { mt: 1, p: 1 }, // небольшой отступ сверху и внутренние поля
                        }}
                    >
                        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1, minWidth: 160, alignItems: 'center'}}>
                            <div style={{display: 'flex', flexDirection: 'row', alignItems: 'center'}}>
                                <FormControlLabel label={undefined} sx={{ padding: 0, margin: 0, display: 'flex', flexDirection: 'row', justifyContent: 'center'}}
                                    control={<BoxPalletSwitch defaultChecked={addTypeBP} onChange={(e) => setAddTypeBP(e.target.checked)} />}
                                />
                            </div>
                            <MuiInput
                                sx={{ ':after': { borderBottomColor: '#005b52' }, width: '120px', fontSize: '12px', textAlign: 'center', '& input': { textAlign: 'center' }}}
                                value={addPalletCount}
                                size="medium"
                                onChange={(event) => {
                                    if (event.target.value === '') {
                                        setAddPalletCount(1);
                                    }
                                    else {
                                        let tmp = parseInt(event.target.value, 10)
                                        if (!isNaN(tmp)) {
                                            setAddPalletCount(tmp);
                                        }
                                    }
                                }}
                                inputProps={{
                                    'aria-labelledby': 'input-count',
                                }}
                            />
                            <Button variant='text' 
                                onClick={() => {
                                    // @ts-ignore
                                    if (!addTypeBP) {preventDoubleClick(addBox(addPalletCount, undefined, "box"))}
                                    else {preventDoubleClick(addBox(undefined, undefined, "pallet"))}
                                }}
                                sx={{fontSize: '12px', borderRadius: '10px', height: '20px'}}
                            >
                                Добавить
                            </Button>
                        </Box>
                    </Popover>
                </div>
                {loading? <Loading/>:
                <Scrollbars
                    ref={scrollRef}
                    style={{ height: "85%" }}
                >
                    <CardContent>
                        {boxes.filter((fel) => fel.type === "pallet").map((parel, 
                        // @ts-ignore
                        index) => (
                            <>
                                <ListItemButton onClick={() => handleClick(parel.id)}
                                    disableRipple  
                                    sx={{
                                        borderRadius: '30px',
                                        backgroundColor: parel.open ? '#078476' : "ffffff",
                                        borderStyle: 'solid',
                                        borderWidth: '1px',
                                        borderColor: parel.open ? '#065f52' : '#aaa8a8',
                                        marginBottom: parel.open? '0px': '10px',    
                                        '&:hover': {
                                            backgroundColor: parel.open ? '#065f52' : '#f1f1f1',
                                        },
                                    }}
                                >

                                    <div style={{ width: '100%', display: 'flex', flexDirection: "row", justifyContent: "space-between", alignItems: "center" }}>
                                        <div style={{ display: 'flex', flexDirection: "row", alignItems: "center" }}>
                                            {/* <ListItemText primary={el.id} /> */}
                                            <Typography variant='subtitle2' align='left' style={{ fontWeight: 'bold', color: parel.open ? 'white' : "black"}}>{parel.title}</Typography>
                                            {parel.open ? <ExpandLess style={{color: 'white'}}/> : <ExpandMore style={{color: "black"}}/>}
                                        </div>
                                        <div style={{ display: 'flex', flexDirection: "row", alignItems: "center" }}>
                                            {parel.sku === 0 && <Typography variant='subtitle2' align='right' style={{ marginRight: '10px', color: parel.open ? 'white' : "black"}}>Коробов: {parel.box_count} </Typography>}
                                            {parel.box_count == 0?
                                                <Typography variant='subtitle2' align='right' style={{ marginRight: '10px', color: parel.open ? 'white' : "black"}}>
                                                    SKU: {parel.sku}, Товаров: {parel.count}
                                                </Typography>
                                                :
                                                <Typography variant='subtitle2' align='right' style={{ marginRight: '10px', color: parel.open ? 'white' : "black"}}>
                                                    SKU: {inPalletCount[parel.id]?.sku?.length || 0}, Товаров: {inPalletCount[parel.id]?.count || 0}
                                                </Typography>
                                            }
                                        </div>
                                        <div style={{ display: 'flex', flexDirection: 'row' }}>
                                            {parel.sku === 0 && 
                                                <PalletAddPopover
                                                    parel={parel}
                                                    onAddBox={(palletId, count) => {preventDoubleClick(addBox(count, undefined, "box", palletId))}}
                                                    onAddProduct={(palletId) => {preventDoubleClick(openAddProduct(palletId))}}
                                                    blocked={false}
                                                />
                                            }
                                            {parel.box_count === 0 && parel.sku !==0 && 
                                                <>
                                                    <Tooltip title={`Добавить товар на паллет}`}>
                                                        <IconButton 
                                                            aria-label="menu" 
                                                            onClick={(event) => { event.stopPropagation(); openAddProduct(parel.id) }}
                                                            sx={{ position: 'relative' }}
                                                            
                                                            disableRipple
                                                        >
                                                            <AddIcon
                                                                sx={{
                                                                    transition: 'all 0.3s ease',
                                                                    '&:hover': hoverStyle,
                                                                    position: 'relative',
                                                                    color: parel.open ? 'white' : "black"
                                                                }}
                                                            />
                                                        </IconButton>
                                                    </Tooltip>
                                                </>
                                            }
                                        </div>
                                    </div>
                                </ListItemButton>
                                <Collapse in={parel.open} timeout="auto" unmountOnExit sx={{margin: "0px 15px 10px 15px"}}>
                                    {parel.sku > 0?
                                        <>
                                            {loading? <Loading/> :
                                                <>
                                                    {data[parel.id]? 
                                                        <div style={{display: 'flex', flexDirection: 'row', alignItems: 'center', flexWrap: 'wrap'}}>
                                                            {data[parel.id].map((datael) => {return productItem(parel, datael)})}
                                                        </div>    
                                                    :
                                                        <div style={{width: '100%', display: 'flex', flexDirection: 'row', justifyContent: 'center'}}>Паллет пустой</div>
                                                    }
                                                </>
                                            }
                                        </>
                                        :
                                        <>
                                            {boxes.filter((fel) => fel.type === "box" && fel.parent_id === parel.id).map((el, index) => (
                                                <>
                                                    <ListItemButton onClick={() => handleClick(el.id)}
                                                        sx={{
                                                            borderBottom: '2px solid #b9b9b9ff', 
                                                            backgroundColor: "ffffff",
                                                            borderRadius: '10px',
                                                            borderBottomRightRadius: '0px',
                                                            borderBottomLeftRadius: '0px'
                                                        }}
                                                    >

                                                        <div style={{ width: '100%', display: 'flex', flexDirection: "row", justifyContent: "space-between", alignItems: "center" }}>
                                                            <div style={{ display: 'flex', flexDirection: "row", alignItems: "center" }}>
                                                                {/* <ListItemText primary={el.id} /> */}
                                                                <Typography variant='subtitle2' align='left' style={{ fontWeight: 'bold' }}>{el.title}</Typography>
                                                                {el.open ? <ExpandLess /> : <ExpandMore />}


                                                            </div>
                                                            <div style={{ display: 'flex', flexDirection: "row", alignItems: "center" }}>
                                                                <Typography variant='subtitle2' align='right' style={{ marginRight: '10px' }}>{el.sku} SKU, {el.count} шт.</Typography>
                                                                <Tooltip title={`Добавить товар в короб`}>
                                                                    <IconButton aria-label="menu" onClick={(event) => { event.stopPropagation(); openAddProduct(el.id) }}  disableRipple>
                                                                        <AddIcon
                                                                            sx={{
                                                                                transition: 'all 0.3s ease',
                                                                                '&:hover': hoverStyle
                                                                            }}
                                                                        />
                                                                    </IconButton>
                                                                </Tooltip>
                                                            </div>
                                                        </div>
                                                    </ListItemButton>
                                                    <Collapse in={el.open} timeout="auto" unmountOnExit>
                                                        {loading? <Loading/> :
                                                            <>
                                                            {data[el.id]? 
                                                                <div style={{display: 'flex', flexDirection: 'row', alignItems: 'center', flexWrap: 'wrap'}}>
                                                                    {data[el.id].map((datael) => {return productItem(el, datael)})}
                                                                </div>    
                                                            :
                                                                <div style={{width: '100%', display: 'flex', flexDirection: 'row', justifyContent: 'center'}}>Короб пустой</div>
                                                            }
                                                            </>
                                                        }
                                                    </Collapse>
                                                </>
                                            ))}
                                        </>
                                    }
                                </Collapse>
                            </>
                        ))}
                        {/* КООРБА БЕЗ ПАЛЛЕТА */}
                        {boxes.filter((fel) => fel.type === "box" && !fel.parent_id).length > 0 &&
                            <>
                                <ListItemButton onClick={() => setNoPalletOpen(!noPalletOpen)}
                                    sx={{
                                        borderRadius: '30px',
                                        backgroundColor: noPalletOpen ? '#078476' : "ffffff",
                                        borderStyle: 'solid',
                                        borderWidth: '1px',
                                        borderColor: noPalletOpen ? '#065f52' : '#aaa8a8',
                                        marginBottom: '10px',
                                        '&:hover': {
                                            backgroundColor: noPalletOpen ? '#065f52' : '#f1f1f1',
                                        },
                                    }}
                                >

                                    <div style={{ width: '100%', display: 'flex', flexDirection: "row", justifyContent: "space-between", alignItems: "center" }}>
                                        <div style={{ display: 'flex', flexDirection: "row", alignItems: "center" }}>
                                            {/* <ListItemText primary={el.id} /> */}
                                            <Typography variant='subtitle2' align='left' style={{ fontWeight: 'bold', color: noPalletOpen ? 'white' : "black"}}>Короба без паллета</Typography>
                                            {noPalletOpen ? <ExpandLess sx={{color: 'white'}}/> : <ExpandMore sx={{color: 'black'}}/>}
                                        </div>
                                    </div>
                                </ListItemButton>
                                <Collapse in={noPalletOpen} timeout="auto" unmountOnExit sx={{marginLeft: "10px"}}>
                                    {boxes.filter((fel) => fel.type === "box" && !fel.parent_id).map((el) => (
                                        <>
                                            <ListItemButton onClick={() => handleClick(el.id)}
                                                sx={{
                                                    borderBottom: '2px solid #b9b9b9ff', 
                                                    backgroundColor: "ffffff",
                                                    borderRadius: '10px',
                                                    borderBottomRightRadius: '0px',
                                                    borderBottomLeftRadius: '0px'
                                                }}
                                            >

                                                <div style={{ width: '100%', display: 'flex', flexDirection: "row", justifyContent: "space-between", alignItems: "center" }}>
                                                    <div style={{ display: 'flex', flexDirection: "row", alignItems: "center" }}>
                                                        {/* <ListItemText primary={el.id} /> */}
                                                        <Typography variant='subtitle2' align='left' style={{ fontWeight: 'bold' }}>{el.title}</Typography>
                                                        {el.open ? <ExpandLess /> : <ExpandMore />}


                                                    </div>
                                                    <div style={{ display: 'flex', flexDirection: "row", alignItems: "center" }}>
                                                        <Typography variant='subtitle2' align='right' style={{ marginRight: '10px' }}>{el.sku} SKU, {el.count} шт.</Typography>
                                                        <Tooltip title={`Добавить товар в короб`}>
                                                            <IconButton aria-label="menu" onClick={(event) => { event.stopPropagation(); openAddProduct(el.id) }}  disableRipple>
                                                                <AddIcon
                                                                    sx={{
                                                                        transition: 'all 0.3s ease',
                                                                        '&:hover': hoverStyle
                                                                    }}
                                                                />
                                                            </IconButton>
                                                        </Tooltip>
                                                    </div>
                                                </div>
                                            </ListItemButton>
                                            <Collapse in={el.open} timeout="auto" unmountOnExit>
                                                {loading? <Loading/> :
                                                    <>
                                                        {data[el.id]? 
                                                            <div style={{display: 'flex', flexDirection: 'row', alignItems: 'center', flexWrap: 'wrap'}}>
                                                                {data[el.id].map((datael) => {return productItem(el, datael)})}
                                                            </div>    
                                                        :
                                                            <div style={{width: '100%', display: 'flex', flexDirection: 'row', justifyContent: 'center'}}>Короб пустой</div>
                                                        }
                                                    </>
                                                }
                                            </Collapse>
                                        </>
                                    ))}
                                </Collapse>
                            </>
                        }
                    </CardContent>
                </Scrollbars>
                }
            </Card>
        </div>
    );
}



function AddProductsToBox({cli, market, cancel, onSave, type}) {
    const ds = useMemo(() => getDataSource('ReturnsTableModern'), []);
    /** @type {[any, Function]} */
    const [data, setData] = useState({});
    const [loading, setLoading] = useState(false);

    /** @type {any} */
    const textref = useRef(null);

    const { showNotification } = useLocalNotifications();
    const preventDoubleClick = usePreventDoubleClick();

    const { socket } = useContext(SocketContext);

    const { company_id, user_id  } = useSelector(
        loginSelector
    );

    useEffect(() => {
        if (textref.current) {
            textref.current.focus();
        }
    }, []);
    

    const handleCheckboxChange = () => {        
        let tmp = JSON.parse(JSON.stringify(data))
        if (textref.current?.value !== '') {
            if (cli) {
                if (!tmp[textref.current?.value]) {
                    tmp[textref.current?.value] = {count: 1, countDefect: 0, countSelfRet: 0, status: "load", barcode: textref.current?.value}
                    socket.emit("returns_find_barcode_onClient", {barcode: textref.current?.value, market, company_id, user_id, cli})
                }
                else {
                    tmp[textref.current?.value].count +=1
                }
                setData(tmp)
            }
            else {
                showNotification({
                    id: 'failCli', 
                    type: 'error', 
                    message: `Не выбран клиент`
                });
            }
        }

        // Очищаем поле ввода и возвращаем фокус
        if (textref.current) {
            textref.current.value = '';
            textref.current.focus();
        }
    };

    useOn('returns_find_barcode_res', (indata) => {
        let tmp = JSON.parse(JSON.stringify(data))
        console.log("tmp", tmp)
        if (indata.user_id === user_id) {
            //На случай, когда сетевой методд отработал быстрее
            if (!tmp[indata.barcode]) { tmp[indata.barcode] = {count: 1, countDefect: 0, countSelfRet: 0, status: "load", barcode: indata.barcode}}
            if (indata.pr) {


                tmp[indata.barcode].status = 'success'
                tmp[indata.barcode].id = indata.barcode
                tmp[indata.barcode].nmID = indata.pr.nmID
                tmp[indata.barcode].data = {
                    vendorCode:indata.pr.vendorCode,
                    brand:indata.pr.brand,
                    title:indata.pr.title,
                    photo:indata.pr.photo,
                    nmID:indata.pr.nmID,
                    barcode: indata.barcode,
                    sizeTitle: indata.pr.size.title

                }
                tmp[indata.barcode].size = indata.pr.size
                tmp[indata.barcode].cli = indata.pr.cli
                tmp[indata.barcode].material = indata.pr.material
                tmp[indata.barcode].dimensions = indata.pr.dimensions
                tmp[indata.barcode].color = indata.pr.color

                showNotification({
                    id: 'succesLoad', 
                    type: 'success', 
                    message: `Найдент товар ${indata.barcode}`
                });
            }
            else {
                tmp[indata.barcode].status = 'fail'
                showNotification({
                    id: 'failLoad', 
                    type: 'error', 
                    message: `Товар ${indata.barcode} не найден`
                });
            }
            setData(tmp)

            // После обработки ответа возвращаем фокус на поле ввода
            if (textref.current) {
                textref.current.focus();
            }
        }

    });

    const handleKeyDown = (e) => {
        if (e.key === 'Enter') {
            e.preventDefault();
            handleCheckboxChange();
        }
    };

    useEffect(() => {
        setData({})
    }, [market]);

    const changeRow = (INdata) => {
        console.log('INdata', INdata)
        let tmp = JSON.parse(JSON.stringify(data))
        tmp[INdata.row.id].count = INdata.count
        setData(tmp)
    }

    const goBind = async () => {
        let res = []
        let tmp = Object.values(data).filter((fel) => fel.status === 'success')
        if (tmp.length>0) {
            for (let item of tmp) {
                if (item.count === 0 || item.count < item.countDefect + item.countSelfRet) {
                    showNotification({
                        id: 'countERR', 
                        type: 'error', 
                        message: `У товара ${item.size.barcode} некорректное количество`
                    });
                    break
                }
                let tztext = ""
                switch (type) {
                    case "return": {tztext = "Возврат"; break}
                    case "selfret": {tztext = "Самовыкуп"; break}
                    case "defect": {tztext = "Брак"; break}
                }
                res.push(
                    {
                        client_id: item.cli,
                        nmID: item.nmID,
                        countEtimated: 0,
                        countProduct: item.count - item.countDefect - item.countSelfRet,
                        vendorCode: item.data.vendorCode,
                        brand: item.data.brand,
                        title: item.data.title,
                        photo: item.data.photo,
                        material: item.material,
                        color: item.color,
                        size: {...item.size, techTask: {
                            text:tztext,
                            services: undefined,
                            print: 'classic',
                            version: type
                        }},
                        dimensions: item.dimensions
                    }
                )
            }
            onSave(res)
        }
        else {
            showNotification({
                id: 'binderr', 
                type: 'error', 
                message: 'Ни один товар не выбран' 
            });
        }
    }

    const handleClickDelBarcode = (id) => {
        let tmp = JSON.parse(JSON.stringify(data))
        delete tmp[id]
        setData(tmp)
    }

    return (
        <Box sx={{height: '100%', width: "100%", padding: "1%"}}>
            <div style={{width: "100%", height: "100%", backgroundColor: 'white', borderRadius: "10px", padding: "1%"}}>
                <div style={{width: "100%", height: "8%", display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'space-between'}}>
                    <div style={{width: "90%", display: 'flex', flexDirection: 'row', alignItems: 'center'}}>
                        <TextField
                            inputRef={textref}
                            placeholder={"Баркод"}
                            onKeyDown={handleKeyDown}
                            sx={{
                                width: "40%",
                                borderRadius: '10px',
                                backgroundColor: '#F5F9FA',//'rgba(255, 255, 255, 0.6)',
                                paddingLeft: "16px",
                                '& .MuiInput-underline': {
                                    '&:before': { borderBottom: 'none' },
                                    '&:after': { borderBottom: 'none' },
                                    '&:hover:not(.Mui-disabled):before': { borderBottom: 'none' },
                                },
                            }}
                            InputProps={{
                                endAdornment: (
                                    <IconButton
                                        onClick={() => handleCheckboxChange()}
                                    >
                                        <AddCircleOutlineIcon/>
                                    </IconButton>
                                )
                            }}
                            variant="standard"
                        />
                    </div>
                </div>
                <div style={{width: "100%", height: "88%", display: 'flex', flexDirection: "row", justifyContent: 'space-between'}}>
                    <div style={{width: "69%", height: "100%"}}>
                        {loading?
                            <Loading />
                            :
                            <Scrollbars
                                style={{ width: '100%', height: '100%', borderBottomLeftRadius: "10px", borderBottomRightRadius: "10px" }}
                            >
                                <ReportTable 
                                    ds={ds} 
                                    data={Object.values(data).filter((fel) => fel.status === 'success')} 
                                    onFormatterChange={changeRow}
                                    customNoDataText={"Вы пока не добавили товары"}
                                    aditionalAction={
                                        [
                                            {
                                                action: (item) => {handleClickDelBarcode(item.id)},
                                                ui: () => {return (
                                                    <DeleteForeverIcon
                                                        sx={{
                                                            transition: 'all 0.3s ease',
                                                            '&:hover': hoverStyle
                                                        }}
                                                    />
                                                )}
                                            }
                                        ]
                                    }
                                />
                            </Scrollbars>
                        }
                    </div>
                    <div style={{width: "30%", height: "100%"}}>
                        <Scrollbars
                            style={{ width: '100%', height: '100%', borderBottomLeftRadius: "10px", borderBottomRightRadius: "10px" }}
                        >
                            {Object.values(data).map((pr, index) => 
                                <Card
                                    key={index} // или используйте уникальный id, если есть
                                    sx={{ 
                                        margin: 1,
                                        borderRadius: "10px",
                                        boxShadow: 1,
                                        height: '8%',
                                        display: 'flex',
                                        alignItems: 'center'
                                    }}
                                >
                                    <CardContent sx={{flex: 1, display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginTop:"8px"}}>
                                        <div style={{display: 'flex', flexDirection: 'row', alignItems: 'center'}}>
                                            <Typography variant="body1" fontWeight="bold" sx={{marginRight: "20px"}}>
                                                {pr.barcode}
                                            </Typography>
                                            <Typography variant="body1" color="text.secondary">
                                                {pr.count} шт.
                                            </Typography>
                                        </div>
                                        {pr.status === 'success' && <CheckCircleIcon color="success" />}
                                        {pr.status === 'fail' && <CancelIcon color="error" />}
                                        {pr.status === 'load' && <Loading/>}
                                    </CardContent>
                                </Card>
                            )}
                        </Scrollbars>
                    </div>
                </div>
            </div>
            <Box
                sx={{
                    display: "flex",
                    flexDirection: "row",
                    justifyContent: "space-between",
                    height: "2%",
                    alignItems: "center",
                }}
            >

                <Button
                    onClick={() => cancel(false)}
                    variant="text" 
                    sx={{ 
                        height: "35px", 
                        width: "150px", 
                        textTransform: 'none', 
                        fontWeight: 'bold', 
                        marginBottom: '10px',
                        marginTop: '10px',
                        fontSize: "20px",
                        borderRadius: "10px"
                    }}
                >
                    Отмена
                </Button>
                <Button
                    onClick={preventDoubleClick(goBind, 1000)}
                    variant="contained"
                    size="medium"
                    sx={{ 
                        height: "35px", 
                        width: "150px", 
                        textTransform: 'none', 
                        backgroundColor: colors.elements, 
                        fontWeight: 'bold', 
                        marginBottom: '10px',
                        marginTop: '10px',
                        fontSize: "20px",
                        borderRadius: "10px"
                    }}
                    disabled={Object.keys(data).length === 0}
                >
                    Добавить
                </Button>
            </Box>
        </Box>
    );
}